(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34],{

/***/ 6562:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-enrollment/welcome",
      function () {
        return __webpack_require__(13876);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        logoPrimary: {
            maxWidth: "100px"
        },
        logoSecondary: (_obj = {
            maxWidth: "90px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
            maxWidth: "142px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "& path", {
            fill: theme.palette.care.navy[800]
        }), _obj)
    };
});
var CareLogo = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant;
    var classes = useStyles();
    var logoClass = variant === "secondary" ? classes.logoSecondary : classes.logoPrimary;
    // todo: add blue Care for Business logo to shared library
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        "data-testid": "careAltLogo",
        width: "100%",
        viewBox: "0 0 100 40",
        fill: "none",
        className: logoClass,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.11685 32.681H5.77924V31.5903H7.11685V30.9793C7.11685 29.3259 8.05331 28.384 9.45736 28.384C9.92496 28.384 10.36 28.467 10.6784 28.6653L10.3612 29.5912C10.1606 29.4759 9.92622 29.409 9.6429 29.409C8.82303 29.409 8.37173 29.9704 8.37173 30.9793V31.5903H10.0102V32.681H8.37173V39.5732H7.11811V32.681H7.11685Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.028 35.574C11.028 33.2601 12.5662 31.3923 15.0233 31.3923C17.4804 31.3923 19.0185 33.2601 19.0185 35.574C19.0185 37.8879 17.4804 39.7718 15.0233 39.7718C12.5662 39.7718 11.028 37.8879 11.028 35.574ZM17.6985 35.574C17.6985 33.9541 16.7457 32.4991 15.0233 32.4991C13.3008 32.4991 12.3317 33.9541 12.3317 35.574C12.3317 37.1939 13.302 38.665 15.0233 38.665C16.7445 38.665 17.6985 37.21 17.6985 35.574Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21.0599 31.5893H22.3135V32.8783C22.9654 32.0355 23.9019 31.4232 25.0051 31.4232V32.6961C24.8546 32.6626 24.7042 32.6465 24.5036 32.6465C23.7351 32.6465 22.6808 33.2749 22.3135 33.9194V39.5722H21.0599V31.5893Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30.9397 28.5479H35.9053C37.8446 28.5479 39.0318 29.7042 39.0318 31.3576C39.0318 32.7457 38.0953 33.6715 37.0761 33.8872C38.2633 34.0694 39.2499 35.2753 39.2499 36.5977C39.2499 38.3664 38.0627 39.5723 36.0231 39.5723H30.9409V28.5479H30.9397ZM35.6708 33.3245C36.9245 33.3245 37.5939 32.5648 37.5939 31.5559C37.5939 30.547 36.9257 29.7712 35.6708 29.7712H32.3274V33.3245H35.6708ZM35.7373 38.349C37.041 38.349 37.8108 37.6215 37.8108 36.4478C37.8108 35.4389 37.1087 34.5465 35.7373 34.5465H32.3262V38.3478H35.7373V38.349Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M46.8553 38.4502C46.2372 39.1443 45.1829 39.7727 43.9795 39.7727C42.2909 39.7727 41.4045 38.9621 41.4045 37.227V31.5902H42.6582V36.8465C42.6582 38.2519 43.3777 38.6647 44.4634 38.6647C45.45 38.6647 46.3864 38.1032 46.854 37.4575V31.5902H48.1076V39.5731H46.854V38.449L46.8553 38.4502Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M50.5663 37.6209C51.1016 38.232 52.1208 38.7612 53.2252 38.7612C54.4625 38.7612 55.1307 38.2159 55.1307 37.4388C55.1307 36.5625 54.1441 36.2824 53.0572 36.0172C51.6858 35.7036 50.1313 35.3392 50.1313 33.6871C50.1313 32.4477 51.2182 31.3893 53.14 31.3893C54.5114 31.3893 55.4805 31.9012 56.1323 32.5456L55.5469 33.4045C55.0618 32.8257 54.1754 32.3969 53.14 32.3969C52.0368 32.3969 51.351 32.8927 51.351 33.6041C51.351 34.3812 52.2699 34.6291 53.3242 34.8769C54.7283 35.1905 56.3505 35.5871 56.3505 37.3557C56.3505 38.6943 55.2636 39.7688 53.1738 39.7688C51.8525 39.7688 50.733 39.3722 49.9144 38.5121L50.5663 37.6197V37.6209Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M58.1727 29.4085C58.1727 28.9462 58.5576 28.5819 59.0089 28.5819C59.4602 28.5819 59.8614 28.945 59.8614 29.4085C59.8614 29.8721 59.4765 30.2513 59.0089 30.2513C58.5413 30.2513 58.1727 29.8708 58.1727 29.4085ZM58.3896 31.5899H59.6432V39.5728H58.3896V31.5899Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M67.6026 34.3507C67.6026 32.9453 66.883 32.4991 65.7974 32.4991C64.8108 32.4991 63.8743 33.094 63.4067 33.7385V39.5735H62.1531V31.5906H63.4067V32.7482C63.9746 32.0876 65.079 31.3923 66.2825 31.3923C67.9711 31.3923 68.8574 32.2351 68.8574 33.9702V39.5735H67.6038V34.3507H67.6026Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M74.8736 31.3923C77.3144 31.3923 78.7523 33.2762 78.7523 35.6732V35.9867H72.2159C72.3162 37.4913 73.3855 38.7468 75.1256 38.7468C76.0445 38.7468 76.9809 38.3837 77.6165 37.7392L78.2182 38.5485C77.4159 39.3418 76.329 39.7718 75.0077 39.7718C72.6171 39.7718 70.8946 38.0689 70.8946 35.574C70.8946 33.2601 72.5669 31.3923 74.8736 31.3923ZM72.2159 35.0782H77.5162C77.4999 33.8884 76.6976 32.4173 74.8585 32.4173C73.1361 32.4173 72.2836 33.855 72.2172 35.0782H72.2159Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M80.7237 37.6209C81.259 38.232 82.2782 38.7612 83.3813 38.7612C84.6187 38.7612 85.2868 38.2159 85.2868 37.4388C85.2868 36.5625 84.3003 36.2824 83.2134 36.0172C81.8419 35.7036 80.2874 35.3392 80.2874 33.6871C80.2874 32.4477 81.3743 31.3893 83.2961 31.3893C84.6676 31.3893 85.6366 31.9012 86.2885 32.5456L85.703 33.4045C85.2179 32.8257 84.3316 32.3969 83.2961 32.3969C82.1929 32.3969 81.5072 32.8927 81.5072 33.6041C81.5072 34.3812 82.4261 34.6291 83.4804 34.8769C84.8844 35.1905 86.5066 35.5871 86.5066 37.3557C86.5066 38.6943 85.4197 39.7688 83.3299 39.7688C82.0086 39.7688 80.8892 39.3722 80.0705 38.5121L80.7224 37.6197L80.7237 37.6209Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M88.498 37.6209C89.0333 38.232 90.0525 38.7612 91.1569 38.7612C92.3942 38.7612 93.0624 38.2159 93.0624 37.4388C93.0624 36.5625 92.0758 36.2824 90.9889 36.0172C89.6175 35.7036 88.063 35.3392 88.063 33.6871C88.063 32.4477 89.1499 31.3893 91.0717 31.3893C92.4431 31.3893 93.4122 31.9012 94.064 32.5456L93.4786 33.4045C92.9935 32.8257 92.1071 32.3969 91.0717 32.3969C89.9685 32.3969 89.2827 32.8927 89.2827 33.6041C89.2827 34.3812 90.2016 34.6291 91.2559 34.8769C92.66 35.1905 94.2822 35.5871 94.2822 37.3557C94.2822 38.6943 93.1953 39.7688 91.1055 39.7688C89.7842 39.7688 88.6647 39.3722 87.8461 38.5121L88.498 37.6197V37.6209Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.94275 6.36124C1.28508 10.1959 1.38787 15.3382 4.04429 19.1307C5.7442 21.5587 8.35549 23.3025 11.2325 24.0647C13.3023 24.6125 15.56 24.6683 17.6385 24.0461C19.1517 23.5937 20.9393 22.5898 21.8983 21.462C22.1227 21.198 22.3446 20.8361 22.3584 20.4841C22.3697 20.2003 22.1603 19.971 21.8795 19.9313C21.5373 19.883 21.1499 20.1557 20.9681 20.2623C20.7977 20.3626 20.4303 20.5733 20.1533 20.7022C19.7095 20.9092 19.2532 21.0716 18.7831 21.2067C15.6039 22.1251 12.3307 20.1668 10.8251 17.429C10.6897 17.1824 10.5656 16.9283 10.454 16.6705C9.89995 15.3914 9.63418 14.0046 9.5389 12.6164C9.42733 10.9842 9.55144 9.32586 10.0316 7.76051C10.5431 6.09229 11.467 4.57279 12.7833 3.40653C13.4778 2.79055 13.9692 2.4745 14.7715 1.92793C15.0235 1.7569 15.2692 1.64287 15.2128 1.37392C15.1413 1.03309 14.8041 0.988473 14.4556 1.00211C14.2914 1.0083 13.7197 1.06655 13.657 1.07275C11.1548 1.3355 7.90794 2.33693 5.62636 4.43522C4.99704 5.01402 4.43041 5.65974 3.944 6.36124H3.94275Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M77.4377 12.6831C77.4591 12.1713 78.0044 12.0845 78.4018 12.0833C79.1138 12.0808 79.6165 12.1254 80.4251 11.8131C81.6737 11.3309 82.5851 10.1783 82.7719 8.89554C83.0088 7.26574 82.1025 5.60495 80.6583 4.97038C80.6169 4.95179 80.5292 4.91337 80.4966 4.89974C79.184 4.35688 77.622 4.65186 76.5201 5.56033C76.1114 5.89745 75.7742 6.3176 75.5222 6.78113C74.7074 8.27832 74.4203 9.99612 74.4968 11.6829C74.6785 15.6589 76.5439 19.2469 80.5204 20.5718C81.8016 20.9994 83.1618 20.9647 83.9791 20.7578C84.5771 20.6066 85.135 20.3463 85.6602 20.0265C86.178 19.7117 86.5779 19.4155 87.2059 18.9693C87.5143 18.7499 87.9481 18.6161 88.2113 19.0201C88.4821 19.4366 88.1223 20.0711 87.8779 20.4206C87.5219 20.9313 87.068 21.3675 86.613 21.7927C85.2591 23.0618 83.5842 23.824 81.7778 24.2367C80.395 24.5528 78.7553 24.5416 77.439 24.3607C74.3062 23.9294 71.3464 22.1843 69.4246 19.7006C68.6098 18.6471 67.9792 17.4548 67.5743 16.1894C66.5526 12.9892 67.0352 9.45946 68.8342 6.62373C69.4346 5.67684 70.1718 4.81422 71.0167 4.07059C72.2227 3.00843 74.5995 1.00309 79.4498 1.00309C84.9331 1.00309 87.7914 3.64423 88.6777 6.21721C89.2468 7.86932 89.1516 9.73956 88.3793 11.3235C87.5068 13.1132 85.7994 14.567 82.3419 14.5459C80.8827 14.5372 79.6103 14.365 78.3178 13.801C77.8063 13.5767 77.4152 13.2359 77.4377 12.6831Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M57.8281 20.4012C57.8281 20.8573 57.8281 21.5922 57.8306 22.0483C57.8319 22.8279 57.9924 23.5343 58.8724 23.8219C59.0441 23.8789 59.1733 23.988 59.1444 24.1838C59.1106 24.4056 58.9351 24.4738 58.7332 24.4862C58.5878 24.4949 58.4412 24.4912 58.2957 24.4912C55.6042 24.4912 52.5379 24.4912 49.8463 24.4912C49.6796 24.4912 49.5116 24.4936 49.3461 24.4763C49.1731 24.4577 49.0102 24.3945 48.9763 24.2011C48.9412 24.0066 49.0566 23.8901 49.2358 23.8355C50.0895 23.574 50.2901 22.9109 50.2901 22.1425C50.2939 16.714 50.2976 11.0066 50.2851 5.57803C50.2839 4.85423 50.1309 4.17008 49.2484 3.96063C49.0779 3.91973 48.9513 3.79579 48.9763 3.59748C49.0102 3.34465 49.2057 3.2678 49.4264 3.25045C50.2613 3.186 51.4497 3.00505 52.2583 2.80799C53.9206 2.40271 55.514 1.80036 57.0898 1.1472C57.7115 0.889411 57.8444 0.9551 57.8457 1.59587C57.8457 2.07551 57.8494 6.87816 57.8494 7.35904C57.8494 8.78062 57.8294 19.9203 57.8294 20.3999L57.8281 20.4012Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.334 8.43944C21.4111 8.43944 23.0949 6.77476 23.0949 4.72127C23.0949 2.66777 21.4111 1.00309 19.334 1.00309C17.257 1.00309 15.5732 2.66777 15.5732 4.72127C15.5732 6.77476 17.257 8.43944 19.334 8.43944Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M31.7447 8.43943C33.8218 8.43943 35.5056 6.77474 35.5056 4.72125C35.5056 2.66776 33.8218 1.00307 31.7447 1.00307C29.6676 1.00307 27.9838 2.66776 27.9838 4.72125C27.9838 6.77474 29.6676 8.43943 31.7447 8.43943Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M62.8351 8.43944C64.9122 8.43944 66.5959 6.77476 66.5959 4.72127C66.5959 2.66777 64.9122 1.00309 62.8351 1.00309C60.758 1.00309 59.0742 2.66777 59.0742 4.72127C59.0742 6.77476 60.758 8.43944 62.8351 8.43944Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M94.3009 24.4736C96.3779 24.4736 98.0617 22.8089 98.0617 20.7554C98.0617 18.7019 96.3779 17.0372 94.3009 17.0372C92.2238 17.0372 90.54 18.7019 90.54 20.7554C90.54 22.8089 92.2238 24.4736 94.3009 24.4736Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M44.7311 14.1535C44.7311 16.6621 44.7236 19.3367 44.7211 21.8452C44.7211 22.7239 44.7838 23.5605 45.8431 23.8691C46.0048 23.9162 46.0637 24.055 46.0386 24.2124C46.0173 24.3463 45.917 24.4343 45.7879 24.4566C45.6249 24.4839 45.457 24.4938 45.2915 24.4938C42.8093 24.4963 40.5089 24.4665 38.0268 24.4888C37.4614 24.4938 37.2733 24.3352 37.2771 23.7502C37.2796 23.4676 37.2859 23.2197 37.2821 22.8875C37.2796 22.6954 37.2696 22.4661 37.0527 22.3893C36.8396 22.3137 36.6992 22.4947 36.5625 22.6322C35.868 23.3238 35.1021 23.7811 34.1619 24.1294C31.2071 25.2226 26.9134 23.7043 25.6034 21.0904C24.4175 18.7219 25.0882 16.1118 27.2532 14.446C28.6798 13.3479 30.2581 12.6415 31.8803 11.7702C33.1941 11.0166 34.5154 10.2792 35.6725 9.28769C38.1258 7.18692 38.3138 4.28674 36.1325 1.90463C35.8216 1.56503 35.9006 1.19817 36.3544 1.1424C39.0234 0.8152 41.5845 0.942858 43.5891 3.05602C44.518 4.03514 44.7437 5.17538 44.7311 6.56722C44.7086 9.09682 44.7311 11.6252 44.7311 14.1548V14.1535ZM37.2056 15.0769C37.2056 13.9069 37.2006 12.7357 37.2081 11.5657C37.2107 11.1369 37.2483 10.9646 36.7493 11.2546C35.5985 11.9239 34.4828 12.6402 33.5062 13.54C32.0044 14.9244 31.1043 16.5852 31.0855 18.6277C31.0704 20.2873 32.0658 21.6841 33.4247 21.9159C35.2726 22.2319 37.1467 20.5649 37.1994 18.5274C37.2295 17.3784 37.2044 16.227 37.2056 15.0769Z",
                fill: "#EF5844"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M95.4315 39.7886H95.6374V38.3276H96.1634V38.1453H94.908V38.3276H95.4315V39.7886Z",
                fill: "#EF5944"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M97.8514 39.7886H98.0574V38.1453H97.7621L97.246 39.3969L96.7324 38.1453H96.4372V39.7886H96.6431V38.4212L97.2038 39.7886H97.2882L97.8514 38.4212V39.7886Z",
                fill: "#EF5944"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CareLogo);


/***/ }),

/***/ 99051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export policyClickData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72235);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);






// Constants
var ref = next_config__WEBPACK_IMPORTED_MODULE_2___default()(), CZEN_GENERAL = ref.publicRuntimeConfig.CZEN_GENERAL;
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return {
        textContainer: {
            marginTop: theme.spacing(2)
        },
        termsText: {
            color: theme.palette.care.white
        },
        termsLink: {
            color: theme.palette.care.white,
            "&:hover,&:focus,&:focus:active": {
                color: theme.palette.care.white
            }
        }
    };
});
var TERMS_OF_USE = _constants__WEBPACK_IMPORTED_MODULE_3__/* .TEXTS.STATIC.TERMS_OF_USE */ .oS.STATIC.TERMS_OF_USE;
/* eslint-disable camelcase */ var policyClickData = {
    terms: {
        name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .EventNames.TERMS_OF_USE_CLICKED */ .Vy.TERMS_OF_USE_CLICKED,
        link_text: "Terms of Use"
    },
    privacy: {
        name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .EventNames.PRIVACY_POLICY_CLICKED */ .Vy.PRIVACY_POLICY_CLICKED,
        link_text: "Privacy Policy"
    }
};
var TermsOfUse = function(param) {
    var amplitudeLogger = param.amplitudeLogger, buttonCaption = param.buttonCaption, _flat = param.flat, flat = _flat === void 0 ? false : _flat, _variant = param.variant, variant = _variant === void 0 ? "full" : _variant;
    var handlePolicyEvent = function(key) {
        return function() {
            return amplitudeLogger(policyClickData[key]);
        };
    };
    var classes = useStyles();
    var abbreviatedTOU = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: flat ? "" : classes.textContainer,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: "body3",
            color: "textSecondary",
            children: [
                "By choosing ",
                buttonCaption,
                " you agree to our\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "terms-of-use-link",
                    inline: true,
                    onClick: handlePolicyEvent("terms"),
                    href: "".concat(CZEN_GENERAL, "/enterprise/terms.do"),
                    target: "_blank",
                    variant: "link3",
                    rel: "noreferrer",
                    children: policyClickData.terms.link_text
                }),
                " and ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "privacy-policy-link",
                    inline: true,
                    onClick: handlePolicyEvent("privacy"),
                    href: "".concat(CZEN_GENERAL, "/about/privacy-policy/"),
                    variant: "link3",
                    target: "_blank",
                    rel: "noreferrer",
                    children: policyClickData.privacy.link_text
                }),
                "."
            ]
        })
    });
    var fullTOU = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            abbreviatedTOU,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.textContainer,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body3",
                    color: "textSecondary",
                    children: TERMS_OF_USE.CONTENT
                })
            })
        ]
    });
    if (variant === "abbreviated") {
        return abbreviatedTOU;
    }
    if (variant === "universal") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "disclaimer2",
                className: classes.termsText,
                children: [
                    "By clicking ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                        children: buttonCaption
                    }),
                    " you agree to our\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "terms-of-use-link",
                        inline: true,
                        onClick: handlePolicyEvent("terms"),
                        href: "".concat(CZEN_GENERAL, "/enterprise/terms.do"),
                        target: "_blank",
                        variant: "link4",
                        rel: "noreferrer",
                        className: classes.termsLink,
                        children: policyClickData.terms.link_text
                    }),
                    " and ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "privacy-policy-link",
                        inline: true,
                        onClick: handlePolicyEvent("privacy"),
                        href: "".concat(CZEN_GENERAL, "/about/privacy-policy/"),
                        variant: "link4",
                        target: "_blank",
                        rel: "noreferrer",
                        className: classes.termsLink,
                        children: policyClickData.privacy.link_text
                    }),
                    "."
                ]
            })
        });
    }
    return fullTOU;
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsOfUse);


/***/ }),

/***/ 13876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ WelcomePage_WelcomePage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/shared/CareLogo.tsx
var CareLogo = __webpack_require__(91133);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/LandingPageHeader/LandingPageHeader.js
var LandingPageHeader = __webpack_require__(87372);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/AppFooter.tsx
var AppFooter = __webpack_require__(40576);
// EXTERNAL MODULE: ./src/utilities/analyticsHelper.ts + 1 modules
var analyticsHelper = __webpack_require__(44730);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./src/context/FeatureFlagsContext.tsx
var FeatureFlagsContext = __webpack_require__(13854);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/hooks/useDirectEnrollmentData.ts + 1 modules
var useDirectEnrollmentData = __webpack_require__(86477);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Typography/Typography.js
var Typography = __webpack_require__(72235);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 49 modules
var theme = __webpack_require__(38042);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
;// CONCATENATED MODULE: ./src/components/hooks/useResponsive.ts

function useResponsive() {
    var ref, ref1, ref2, ref3;
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.down("xs"));
    var isTablet = (0,useMediaQuery/* default */.Z)((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.only("sm"));
    var isDesktop = (0,useMediaQuery/* default */.Z)((ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.up("md"));
    var isLargeDesktop = (0,useMediaQuery/* default */.Z)((ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.up("lg"));
    return {
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop,
        isLargeDesktop: isLargeDesktop
    };
}
/* harmony default export */ var hooks_useResponsive = (useResponsive);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/WaveDivider/WaveDivider.tsx




var POSITION;
(function(POSITION) {
    POSITION["RELATIVE"] = "relative";
    POSITION["ABSOLUTE"] = "absolute";
})(POSITION || (POSITION = {}));
var useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        waveContainer: {
            position: "relative",
            width: "100%"
        },
        wave: {
            bottom: "-1px",
            position: function(param) {
                var position = param.position;
                return position;
            },
            width: "100%",
            height: function(param) {
                var height = param.height;
                return "".concat(height, "px");
            },
            backgroundColor: function(param) {
                var backgroundColor = param.backgroundColor;
                return backgroundColor;
            },
            zIndex: 10,
            "& svg": {
                position: "absolute",
                top: "0",
                display: "block",
                width: "100%",
                height: function(param) {
                    var height = param.height;
                    return "".concat(height, "px");
                },
                transform: function(param) {
                    var flipVertical = param.flipVertical, flipHorizontal = param.flipHorizontal;
                    if (flipHorizontal) {
                        return "scaleX(-1)";
                    }
                    return flipVertical ? "rotateX(180deg)" : "inherit";
                }
            }
        },
        shapeFill: {
            fill: function(param) {
                var shapeFill = param.shapeFill;
                return shapeFill;
            }
        }
    };
});
function WaveDivider(param) {
    var position = param.position, shapeFill = param.shapeFill, backgroundColor = param.backgroundColor, flipVertical = param.flipVertical, flipHorizontal = param.flipHorizontal;
    var ref = hooks_useResponsive(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var width = "100%";
    var height = isMobile || isTablet ? 27 : 40;
    var classes = useStyles({
        backgroundColor: flipVertical ? shapeFill : backgroundColor,
        height: height,
        position: position,
        shapeFill: flipVertical ? backgroundColor : shapeFill,
        flipVertical: flipVertical,
        flipHorizontal: flipHorizontal
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.waveContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.wave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "none",
                width: width,
                height: height,
                viewBox: "0 0 1440 40",
                preserveAspectRatio: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.79799e-06 16.3212C5.79799e-06 16.3212 230.115 -20.4015 720 16.3212C1290.24 59.0674 1440 9.49196 1440 9.49196L1440 40L3.49692e-06 40.0001L5.79799e-06 16.3212Z",
                    className: classes.shapeFill
                })
            })
        })
    });
}
WaveDivider.defaultProps = {
    position: POSITION.RELATIVE,
    shapeFill: "#000000",
    backgroundColor: "transparent",
    flipVertical: false
};
/* harmony default export */ var WaveDivider_WaveDivider = (WaveDivider);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/text.ts
var BENEFITS_COPY = {
    HEADER: "Stay focused at work while we help you at home",
    DISCLAIMER: "Specific employer benefits may vary. Enroll now to discover the employer benefits available to you."
};
var ENROLLMENT_CTA_TEXT = "Join now";

;// CONCATENATED MODULE: ./public/static/PhoneChildCare.webp
/* harmony default export */ var PhoneChildCare = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/PhoneChildCare.ff18a923.webp","height":900,"width":416,"blurDataURL":"data:image/webp;base64,UklGRmoAAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSBMAAAABD/D8/4iIIBZMeuevHERE/0MDAFZQOCAwAAAA0AEAnQEqBAAIAAJAOCWcAnQBDw7kJbgA/tUX/dM7mrliAF4cAtmS+IQZcrQGgAAA","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/PhoneSeniorCare.webp
/* harmony default export */ var PhoneSeniorCare = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/PhoneSeniorCare.cff828b0.webp","height":900,"width":416,"blurDataURL":"data:image/webp;base64,UklGRnIAAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSBMAAAABD/D8/4iIIBZMeuevHERE/0MDAFZQOCA4AAAA8AEAnQEqBAAIAAJAOCWUAnRH/4HoArigAP7Hg/7Z0l5WzG1S0buHFI6lGU+hdgRKE5pMKJ1EAAA=","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/PhonePetCare.webp
/* harmony default export */ var PhonePetCare = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/PhonePetCare.c637cbab.webp","height":900,"width":416,"blurDataURL":"data:image/webp;base64,UklGRmgAAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSBMAAAABD/D8/4iIIBZMeuevHERE/0MDAFZQOCAuAAAAsAEAnQEqBAAIAAJAOCUAToAh4d3PQAD+/Ti3KAIrIPf7wJWgWNEQL/SMtFQAAA==","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/PhoneSelfCare.webp
/* harmony default export */ var PhoneSelfCare = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/PhoneSelfCare.bcad7db1.webp","height":900,"width":416,"blurDataURL":"data:image/webp;base64,UklGRnQAAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSBMAAAABD/D8/4iIIBZMeuevHERE/0MDAFZQOCA6AAAAsAEAnQEqBAAIAAJAOCWUAnQBDrsEgAD9/T/o5dxFlTYkIFE0iMyyjhd110TJi2nkLrxByi8swoAAAA==","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/PhoneMore.webp
/* harmony default export */ var PhoneMore = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/PhoneMore.16ce3790.webp","height":900,"width":416,"blurDataURL":"data:image/webp;base64,UklGRmAAAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSBMAAAABD/D8/4iIIBZMeuevHERE/0MDAFZQOCAmAAAAkAEAnQEqBAAIAAJAOCWkAALnWMEAAP77MxuMHfwHfYMzpooAAAA=","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/benefits.ts





var BENEFITS = [
    {
        title: "Child Care",
        headline: "Care for kids of all ages",
        subHeadline: "Employee child care benefits",
        description: "We make it easy to find trusted, flexible care for kids at every age and stage with:",
        valueProps: [
            "Subsidized Backup Care for times when school is out, daycare is closed, or your nanny is sick.",
            "Access to our network of hundreds of thousands of background-checked caregivers to find the right one for your family.",
            "Educational support with tutoring for K-12 plus college, as well as college admissions coaching.", 
        ],
        poster: {
            src: PhoneChildCare.src,
            alt: "Child poster"
        }
    },
    {
        title: "Senior Care",
        headline: "Your senior care support system",
        subHeadline: "Employee senior care benefits",
        description: "When an older loved one needs help, your Care employee benefits make it easy to find the right options, including:",
        valueProps: [
            "Expert senior Care Specialists to provide guidance and resources to help you navigate a loved one's aging journey.",
            "Assistance when your senior's caregiver is on vacation, your aging parent needs some help after an injury, or a ride to a doctor's appointment.",
            "Access to the leading platform to find experienced adult caregivers, companion care, and other support.", 
        ],
        poster: {
            src: PhoneSeniorCare.src,
            alt: "Senior poster"
        }
    },
    {
        title: "Pet Care",
        headline: "Purr-fect pet care",
        subHeadline: "Employee pet care benefits",
        description: "Finding someone to take care of your pet is easy with Care's employee pet care benefits such as:",
        valueProps: [
            "Subsidized pet Backup Care when you need to travel for work, work additional shifts, or your regular pet caregiver is on vacation and you need to work.",
            "Access to our network of background-checked pet sitters, dog walkers and groomers, doggy daycares, and pet boarding.", 
        ],
        poster: {
            src: PhonePetCare.src,
            alt: "Pet poster"
        }
    },
    {
        title: "Self Care",
        headline: "Care for you, too",
        subHeadline: "Employee self-care benefits",
        description: "Knowing someone is there for you can make a world of difference. Care's employee self-care benefits can help you find care that fits your specific needs, including:",
        valueProps: [
            "Subsidized care that can come to your home for support during recovery from illness, injury, or surgery.",
            "Access to the leading platform to find background-checked home care, transportation services, and moving support, as well as caregivers for errands, chores, and odd jobs.", 
        ],
        poster: {
            src: PhoneSelfCare.src,
            alt: "Self care poster"
        }
    },
    {
        title: "More Care",
        headline: "Find more, with Care",
        subHeadline: "Additional Care employee benefits",
        description: "We've got a wealth of additional employee benefits for you to explore, including:",
        valueProps: [
            "Exclusive offers on child care, travel, fitness centers, and more through LifeMart discounts.",
            "Personalized caregiving support from our team of expert Care Specialists.",
            "24/7, 1:1 breastfeeding support from Board Certified Lactation Consultants.", 
        ],
        poster: {
            src: PhoneMore.src,
            alt: "More care poster"
        }
    }, 
];

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/AccordionLabel/index.js + 2 modules
var AccordionLabel = __webpack_require__(75822);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/AccordionPanel/index.js + 2 modules
var AccordionPanel = __webpack_require__(71505);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js + 2 modules
var Accordion = __webpack_require__(27959);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitDetails/BenefitDetails.tsx







var DISCLAIMER = BENEFITS_COPY.DISCLAIMER;
var BenefitDetails_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        container: (_obj = {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(4)
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            paddingBottom: 0,
            paddingTop: theme.spacing(6)
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
            paddingLeft: theme.spacing(12),
            paddingRight: theme.spacing(12)
        }), _obj),
        headline: {
            marginBottom: theme.spacing(3)
        },
        subHeadline: {
            color: theme.palette.care.grey[600],
            marginBottom: theme.spacing(1),
            lineHeight: "20px"
        },
        description: {
            marginBottom: theme.spacing(3)
        },
        valuePropList: (0,_define_property/* default */.Z)({
            marginTop: 0,
            marginBottom: theme.spacing(4),
            paddingLeft: theme.spacing(4)
        }, theme.breakpoints.up("md"), {
            paddingLeft: theme.spacing(3),
            marginBottom: theme.spacing(6)
        }),
        valueProp: {
            marginBottom: "12px"
        },
        posterContainer: (0,_define_property/* default */.Z)({
            textAlign: "center",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            textAlign: "right"
        }),
        posterImage: {
            width: "100%",
            maxWidth: "208px",
            height: "auto",
            display: "inline-block",
            margin: 0
        }
    };
});
var BenefitDetails = function(param) {
    var benefit = param.benefit, renderDesktopView = param.renderDesktopView;
    var classes = BenefitDetails_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        "data-testid": "BenefitDetails",
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: 8,
                    lg: 7,
                    children: [
                        renderDesktopView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body3",
                                    component: "h4",
                                    className: classes.subHeadline,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: benefit.subHeadline
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "serifHeadline2",
                                    component: "h3",
                                    className: classes.headline,
                                    children: benefit.headline
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            className: classes.description,
                            children: benefit.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: classes.valuePropList,
                            children: benefit.valueProps.map(function(valueProp) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: classes.valueProp,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: valueProp
                                    })
                                }, valueProp);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                md: 9,
                                children: renderDesktopView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "secondary",
                                    children: DISCLAIMER
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    md: 4,
                    lg: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.posterContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: (0,clsx_m/* default */.Z)(classes.posterImage, "poster-animator"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: benefit.poster.src,
                                alt: benefit.poster.alt,
                                className: classes.posterImage
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BenefitDetails_BenefitDetails = (BenefitDetails);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitDetails/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitsAccordions/BenefitsAccordions.tsx






var BenefitsAccordions_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        // todo: reach out to web platform about overriding these accordion styles
        accordionContainer: {
            "& .MuiAccordionSummary-root": {
                borderBottom: "1px solid ".concat(theme.palette.grey[300]),
                height: "auto",
                alignItems: "flex-start",
                paddingTop: theme.spacing(3),
                paddingBottom: theme.spacing(3)
            },
            "& .MuiAccordion-root:last-of-type .MuiAccordionSummary-root": {
                borderBottom: "none"
            },
            "& .MuiAccordionSummary-content": {
                margin: 0,
                flexDirection: "column"
            },
            "& .accordion-label-primary p": {
                fontWeight: "bold",
                fontSize: "1.25rem",
                lineHeight: "21px"
            }
        }
    };
});
var BenefitsAccordions = function(param) {
    var benefits = param.benefits, logger = param.logger;
    var classes = BenefitsAccordions_useStyles();
    var accordionClick = function(linkText) {
        logger({
            name: constants/* EventNames.LINK_INTERACTED */.Vy.LINK_INTERACTED,
            data: {
                link_text: "".concat(linkText, " clicked")
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "BenefitsAccordions",
        className: classes.accordionContainer,
        children: benefits.map(function(benefit) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                elevation: 0,
                onChange: function() {
                    return accordionClick(benefit.title);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionLabel/* default */.Z, {
                        primaryLabel: benefit.title,
                        secondaryLabel: benefit.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionPanel/* default */.Z, {
                        noPadding: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitDetails_BenefitDetails, {
                            benefit: benefit
                        })
                    })
                ]
            }, benefit.title);
        })
    });
};
/* harmony default export */ var BenefitsAccordions_BenefitsAccordions = (BenefitsAccordions);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitsAccordions/index.tsx


// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitsTabs/BenefitsTabs.tsx






var BenefitsTabs_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        tabs: {
            "& .Mui-selected": {
                color: theme.palette.care.red[500]
            },
            "& .MuiTab-root:focus": {
                borderBottomColor: theme.palette.care.red[500]
            },
            "& .MuiTabs-indicator": {
                backgroundColor: theme.palette.care.red[500]
            }
        },
        tabsContainer: {
            position: "relative",
            overflow: "hidden",
            minHeight: "504px",
            "& .tab-content-exit": {
                position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: "100%"
            },
            "@media (prefers-reduced-motion: no-preference)": {
                "& .tab-content-enter": {
                    opacity: 0,
                    "& .poster-animator": {
                        animation: "$slideIn 350ms ".concat(theme.transitions.easing.easeInOut)
                    }
                },
                "& .tab-content-enter-active": {
                    opacity: 1,
                    transition: "opacity 350ms"
                },
                "& .tab-content-exit": {
                    opacity: 1,
                    "& .poster-animator": {
                        animation: "$slideOut 350ms ".concat(theme.transitions.easing.easeInOut)
                    }
                },
                "& .tab-content-exit-active": {
                    opacity: 0,
                    transition: "opacity 350ms"
                }
            }
        },
        "@keyframes slideIn": {
            "0%": {
                opacity: 0,
                transform: "translateX(-150px)"
            },
            "100%": {
                opacity: 1,
                transform: "translateX(0)"
            }
        },
        "@keyframes slideOut": {
            "0%": {
                opacity: 1,
                transform: "translateX(0)"
            },
            "100%": {
                opacity: 0,
                transform: "translateX(150px)"
            }
        }
    };
});
var BenefitsSection = function(param) {
    var logger = param.logger, benefits = param.benefits;
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var classes = BenefitsTabs_useStyles();
    var tabSelect = function(newValue) {
        var selectedBenefit = benefits[newValue];
        if (selectedBenefit) {
            logger({
                name: constants/* EventNames.LINK_INTERACTED */.Vy.LINK_INTERACTED,
                data: {
                    link_text: "".concat(selectedBenefit.title, " clicked")
                }
            });
        }
        setSelectedTab(newValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "BenefitsTabs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                onChange: function(_event, newValue) {
                    return tabSelect(newValue);
                },
                value: selectedTab,
                variant: "fullWidth",
                indicatorColor: "primary",
                className: classes.tabs,
                children: benefits.map(function(tab, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        id: index.toString(),
                        label: tab.title,
                        tabIndex: "0"
                    }, tab.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
                className: classes.tabsContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: benefits.map(function(benefit, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                            in: selectedTab === index,
                            timeout: 350,
                            unmountOnExit: true,
                            classNames: "tab-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitDetails_BenefitDetails, {
                                benefit: benefit,
                                renderDesktopView: true
                            })
                        }, benefit.title);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BenefitsTabs = (BenefitsSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitsTabs/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitsSection/BenefitsSection.tsx












var HEADER = BENEFITS_COPY.HEADER, BenefitsSection_DISCLAIMER = BENEFITS_COPY.DISCLAIMER;
var BenefitsSection_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        wrapper: {
            backgroundColor: theme/* default.palette.care.white */.Z.palette.care.white,
            position: "relative"
        },
        container: (0,_define_property/* default */.Z)({
            paddingTop: theme/* default.spacing */.Z.spacing(7)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            paddingTop: theme/* default.spacing */.Z.spacing(8),
            paddingBottom: theme/* default.spacing */.Z.spacing(10)
        }),
        headline: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme/* default.spacing */.Z.spacing(2),
            paddingLeft: theme/* default.spacing */.Z.spacing(3),
            paddingRight: theme/* default.spacing */.Z.spacing(3)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            marginBottom: theme/* default.spacing */.Z.spacing(6),
            fontSize: theme/* default.typography.serifDisplay3.fontSize */.Z.typography.serifDisplay3.fontSize,
            lineHeight: theme/* default.typography.serifDisplay3.lineHeight */.Z.typography.serifDisplay3.lineHeight
        }),
        disclaimer: {
            textAlign: "center",
            marginBottom: theme/* default.spacing */.Z.spacing(2)
        }
    };
});
var BenefitsSection_BenefitsSection = function(param) {
    var logger = param.logger;
    var classes = BenefitsSection_useStyles();
    var isDesktop = hooks_useResponsive().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-testid": "BenefitsSection",
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "lg",
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "serifHeadline3",
                        component: "h2",
                        className: classes.headline,
                        children: HEADER
                    }),
                    isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsTabs, {
                        benefits: BENEFITS,
                        logger: logger
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "disclaimer2",
                                color: "secondary",
                                className: classes.disclaimer,
                                children: BenefitsSection_DISCLAIMER
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsAccordions_BenefitsAccordions, {
                                benefits: BENEFITS,
                                logger: logger
                            })
                        ]
                    })
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveDivider_WaveDivider, {
                position: POSITION.ABSOLUTE,
                backgroundColor: "transparent",
                shapeFill: theme/* default.palette.care.blue.100 */.Z.palette.care.blue[100]
            })
        ]
    });
};
/* harmony default export */ var components_BenefitsSection_BenefitsSection = (BenefitsSection_BenefitsSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/BenefitsSection/index.tsx


// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 5 modules
var formik_esm = __webpack_require__(56263);
// EXTERNAL MODULE: ./node_modules/@care/enterprise-components/dist/components/ErrorNotification/index.js + 1 modules
var ErrorNotification = __webpack_require__(94587);
// EXTERNAL MODULE: ./node_modules/@care/enterprise-components/dist/components/FormikInlineTextField/index.js + 1 modules
var FormikInlineTextField = __webpack_require__(67134);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(70603);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 85 modules
var es = __webpack_require__(55393);
// EXTERNAL MODULE: ./src/components/request/GQL.tsx
var GQL = __webpack_require__(5400);
;// CONCATENATED MODULE: ./src/components/hooks/useCompanySearchForm.ts












var validationSchema = es/* object */.Ry({
    email: es/* string */.Z_().email("Enter a valid email").required("Email is required"),
    groupShortName: es/* string */.Z_().required("Employer name is required"),
    groupDisplayName: es/* string */.Z_().required("Employer name is required")
});
var useCompanySearchForm = function(logger) {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useDirectEnrollmentData/* default */.ZP)(), fetch = ref1.fetch, update = ref1.update;
    var excludeClients = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_REDIRECT_LD_FLAG.key */.y8.ENT_REDIRECT_LD_FLAG.key);
    var lifeCareTransitionD2EClients = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_LIFECARE_TRANSITION_D2E_CLIENT_FLAG.key */.y8.ENT_LIFECARE_TRANSITION_D2E_CLIENT_FLAG.key);
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var ref3 = (0,react.useState)(""), ssoConnectionPath = ref3[0], setSSOConnectionPath = ref3[1];
    var ref4 = (0,react.useState)(false), memberExists = ref4[0], setMemberExists = ref4[1];
    var ref5 = (0,react.useState)(""), apolloError = ref5[0], setApolloError = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GQL/* VERIFY_EMPLOYEE_EXISTS_BY_EMAIL */.tc, {
        context: {
            skipAuth: true
        }
    }), 2), verifyEmployeeExists = ref6[0], ref7 = ref6[1], verifyEmployeeData = ref7.data, verifyEmployeeError = ref7.error, loading = ref7.loading;
    var storageValue = fetch();
    var companySearchPreFillName = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.groupName) || (storageValue === null || storageValue === void 0 ? void 0 : storageValue.groupDisplayName) || "";
    var shouldAutoFocusEmail = Boolean(companySearchPreFillName) && !storageValue.email;
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var groupShortName, groupDisplayName, email;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsSubmitting(true);
                groupShortName = values.groupShortName, groupDisplayName = values.groupDisplayName, email = values.email;
                update({
                    groupShortName: groupShortName,
                    groupDisplayName: groupDisplayName,
                    email: email
                });
                if (Boolean(excludeClients) && groupShortName in excludeClients) {
                    window.location.href = "".concat(window.location.protocol, "//").concat(window.location.host, "/").concat(groupShortName);
                    return [
                        2
                    ];
                }
                if (email && groupShortName) {
                    verifyEmployeeExists({
                        variables: {
                            input: {
                                email: email,
                                groupShortName: groupShortName
                            }
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelection = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var name, shortName;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = param.name, shortName = param.shortName;
                        formik.setFieldValue("groupShortName", shortName);
                        formik.setFieldValue("groupDisplayName", name);
                        if (!(name.length >= 2)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            formik.setFieldTouched("groupShortName", true, true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            formik.setFieldTouched("groupDisplayName", true, true)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelection(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCompanySearchError = function(errorMessage) {
        formik.setFieldError("groupShortName", errorMessage);
        formik.setFieldTouched("groupShortName", true, false);
    };
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            groupShortName: storageValue.groupShortName,
            groupDisplayName: storageValue.groupDisplayName,
            email: storageValue.email
        },
        validationSchema: validationSchema,
        validateOnBlur: true,
        onSubmit: handleFormSubmit
    });
    var handleVerifyEmployeeSuccess = function(successData) {
        if (successData.memberExists) {
            logger({
                name: constants/* EventNames.ERROR_VIEWED */.Vy.ERROR_VIEWED,
                data: {
                    message: constants/* TEXTS.ERRORS.EMAIL_ALREADY_EXISTS */.oS.ERRORS.EMAIL_ALREADY_EXISTS,
                    step_name: "Welcome",
                    step_number: "0",
                    wps_group: formik.values.groupShortName
                }
            });
            setMemberExists(successData.memberExists);
            return;
        }
        if (ssoConnectionPath) {
            window.location.href = ssoConnectionPath;
        } else if (Boolean(lifeCareTransitionD2EClients) && storageValue.groupShortName in lifeCareTransitionD2EClients) {
            router.push("".concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.LIFECARE_AUTHENTICATION */.O$.LIFECARE_AUTHENTICATION, "?groupShortName=").concat(storageValue.groupShortName));
        } else {
            router.push("".concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.PERSONAL_INFO */.O$.PERSONAL_INFO));
        }
    };
    (0,react.useEffect)(function() {
        if (verifyEmployeeData) {
            var enterpriseVerifyEmployeeExistsByEmail = verifyEmployeeData.enterpriseVerifyEmployeeExistsByEmail;
            if (enterpriseVerifyEmployeeExistsByEmail.__typename === "EnterpriseVerifyEmployeeExistsByEmailSuccess") {
                handleVerifyEmployeeSuccess(enterpriseVerifyEmployeeExistsByEmail);
            }
            if (enterpriseVerifyEmployeeExistsByEmail.__typename === "EnterpriseFailureResponse") {
                setApolloError(enterpriseVerifyEmployeeExistsByEmail.knownErrors[0].message);
            }
            setIsSubmitting(false);
        }
        if (verifyEmployeeError) {
            setIsSubmitting(false);
            setApolloError(constants/* TEXTS.ERRORS.UNEXPECTED_ERROR */.oS.ERRORS.UNEXPECTED_ERROR);
        }
    }, [
        verifyEmployeeData,
        verifyEmployeeError
    ]);
    return {
        formik: formik,
        memberExists: memberExists,
        companySearchPreFillName: companySearchPreFillName,
        shouldAutoFocusEmail: shouldAutoFocusEmail,
        apolloError: apolloError,
        loading: loading,
        isSubmitting: isSubmitting,
        setSSOConnectionPath: setSSOConnectionPath,
        handleSelection: handleSelection,
        handleCompanySearchError: handleCompanySearchError
    };
};
/* harmony default export */ var hooks_useCompanySearchForm = (useCompanySearchForm);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utilities/capitalize.ts
var capitalize = function(string) {
    var ref, ref1;
    return (ref1 = (ref = string === null || string === void 0 ? void 0 : string.split(" ")) === null || ref === void 0 ? void 0 : ref.map(function(word) {
        var ref;
        return "".concat(word === null || word === void 0 ? void 0 : (ref = word[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()).concat(word === null || word === void 0 ? void 0 : word.slice(1));
    })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
};
/* harmony default export */ var utilities_capitalize = (capitalize);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./src/components/hooks/useFindCareGroupName.tsx



var useFindCareGroupName = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GQL/* FIND_CARE_GROUPS_BY_PARTIAL_NAME */.IB, {
        fetchPolicy: "no-cache",
        context: {
            skipAuth: true
        }
    }), 2), getSuggestions = ref[0], ref1 = ref[1], data = ref1.data, error = ref1.error;
    return {
        getSuggestions: getSuggestions,
        data: data,
        error: error
    };
};

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/CompanySearchInput/CompanySearchInput.tsx
/* eslint-disable camelcase */ 










var _ERRORS = constants/* TEXTS.ERRORS */.oS.ERRORS, EMPLOYER_NAME_INVALID = _ERRORS.EMPLOYER_NAME_INVALID, SERVER_ERROR_GENERIC = _ERRORS.SERVER_ERROR_GENERIC;
var numResults = 10;
var minChars = 2;
var maxHeight = "170px";
var CompanySearchInput_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var ref, ref1, ref2;
    return {
        lookup: {
            position: "relative",
            cursor: "pointer",
            "& .suggestions": {
                position: "absolute",
                top: theme.spacing(9),
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15)",
                marginLeft: theme.spacing(1),
                border: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.grey[200],
                borderRadius: "12px",
                zIndex: "3",
                background: (ref1 = theme.palette.care) === null || ref1 === void 0 ? void 0 : ref1.white,
                width: "94%",
                padding: 0,
                maxHeight: maxHeight,
                overflowY: "auto"
            },
            "& li": {
                listStyle: "none",
                padding: theme.spacing(1),
                textTransform: "capitalize",
                cursor: "pointer",
                "&.highlight": {
                    background: (ref2 = theme.palette.care) === null || ref2 === void 0 ? void 0 : ref2.grey[100]
                },
                "&:last-of-type": {
                    marginBottom: 0
                }
            }
        }
    };
});
// This is only used for reference when a selection is made that updates the userInput. If input matches what was selected, we don't want to query again.
var selectedName = "";
var CompanySearchInput = function(param) {
    var onSelection = param.onSelection, onError = param.onError, setSSOConnectionPath = param.setSSOConnectionPath, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, _prefillName = param.prefillName, prefillName = _prefillName === void 0 ? "" : _prefillName, _preFetch = param.preFetch, preFetch = _preFetch === void 0 ? false : _preFetch, inputProps = param.inputProps, helperTextProps = param.helperTextProps;
    var classes = CompanySearchInput_useStyles();
    var suggestionsRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({}), memoizedSuggestions = ref[0], setMemoizedSuggestions = ref[1];
    var groupInputRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(true), initialLoad = ref1[0], setInitialLoad = ref1[1];
    var ref2 = (0,react.useState)(false), showSuggestions = ref2[0], setShowSuggestions = ref2[1];
    var ref3 = (0,react.useState)(false), isFocused = ref3[0], setIsFocused = ref3[1];
    var ref4 = (0,react.useState)(prefillName), userInput = ref4[0], setUserInput = ref4[1];
    var ref5 = (0,react.useState)(0), highlightedSuggestion = ref5[0], setHighlightedSuggestion = ref5[1];
    var ref6 = (0,react.useState)([]), formattedSuggestions = ref6[0], setFormattedSuggestions = ref6[1];
    var isMinChars = function() {
        return (userInput === null || userInput === void 0 ? void 0 : userInput.length) >= minChars;
    };
    var isPreFetching = initialLoad && preFetch && prefillName;
    var resetSelection = function() {
        onSelection({
            name: "",
            shortName: "",
            ssodirectLoginEnabled: false,
            ssoConnectionPath: ""
        });
        selectedName = "";
    };
    var onGetSuggestionsCompleted = function(data) {
        // Filter out nulls and repeated values, and exclude objects without the "name" property
        var newFormattedSuggestions = (data.findCareGroupsByPartialName || []).filter(function(param) {
            var shortName = param.shortName, name = param.name;
            return shortName !== null && name !== undefined;
        }).filter(function(group, index, arr) {
            return arr.findIndex(function(g) {
                return g.shortName === group.shortName;
            }) === index;
        }).map(function(param) {
            var shortName = param.shortName, ssoConnectionPath = param.ssoConnectionPath, ssodirectLoginEnabled = param.ssodirectLoginEnabled, name = param.name;
            return {
                shortName: shortName,
                ssoConnectionPath: ssoConnectionPath,
                ssodirectLoginEnabled: ssodirectLoginEnabled,
                name: utilities_capitalize(name),
                highlighted: false
            };
        });
        setFormattedSuggestions(newFormattedSuggestions);
        var autoSelection = newFormattedSuggestions.filter(function(param) {
            var name = param.name;
            return name.toLowerCase().trim() === userInput.toLowerCase().trim();
        })[0];
        if (autoSelection && !isFocused) {
            handleSuggestionSelect(autoSelection);
        } else if (isPreFetching) {
            setInitialLoad(false);
            setUserInput("");
            resetSelection();
        }
    };
    var ref7 = useFindCareGroupName(), getSuggestions = ref7.getSuggestions, findCareGroupData = ref7.data, serverError = ref7.error;
    var handleOnChange = function(param) {
        var value = param.currentTarget.value;
        setUserInput(value);
    };
    var handleSuggestionSelect = function(param) {
        var name = param.name, shortName = param.shortName, ssodirectLoginEnabled = param.ssodirectLoginEnabled, ssoConnectionPath = param.ssoConnectionPath;
        setUserInput(name);
        onSelection({
            name: name,
            shortName: shortName,
            ssodirectLoginEnabled: ssodirectLoginEnabled,
            ssoConnectionPath: ssoConnectionPath
        }, Boolean(isPreFetching));
        selectedName = name;
        setInitialLoad(false);
        setSSOConnectionPath(ssodirectLoginEnabled ? ssoConnectionPath : "");
        blurInput();
    };
    var handleAutoSelect = function() {
        if (!selectedName) {
            var validOption = formattedSuggestions.filter(function(param) {
                var name = param.name;
                return name.toLowerCase().trim() === userInput.toLowerCase().trim();
            })[0];
            if (validOption) {
                handleSuggestionSelect(validOption);
            }
        }
    };
    var handleOnBlur = function() {
        setIsFocused(false);
        // Race-condition occurs when clicking on a suggestion from the suggestion list due to the onBlue event firing in the same event cycle.
        // Wrapping in a setTimeout allows the previous event cycle to compelete before running handling auto select and error display.
        setTimeout(function() {
            if (!serverError && !selectedName && userInput) {
                onError(EMPLOYER_NAME_INVALID);
            }
            handleAutoSelect();
        }, 0);
    };
    var isSelectedOnlyOption = function() {
        return formattedSuggestions.length === 1 && formattedSuggestions[0].name === selectedName && selectedName === userInput;
    };
    (0,react.useEffect)(function() {
        setShowSuggestions(Boolean(isFocused && isMinChars() && formattedSuggestions.length) && !isSelectedOnlyOption());
    }, [
        isFocused,
        formattedSuggestions,
        userInput,
        selectedName
    ]);
    var handleOnFocus = function() {
        setIsFocused(true);
    };
    var handleHighlightAtIndex = function(index) {
        if (suggestionsRef === null || suggestionsRef === void 0 ? void 0 : suggestionsRef.current) {
            setHighlightedSuggestion(index);
            Array.from(suggestionsRef === null || suggestionsRef === void 0 ? void 0 : suggestionsRef.current.getElementsByTagName("li")).forEach(function(li, i) {
                if (index === i) {
                    li.classList.add("highlight");
                    li.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                } else li.classList.remove("highlight");
            });
        }
    };
    var debouncedGetSuggestions = (0,react.useCallback)((0,debounce/* default */.Z)(function(input) {
        getSuggestions({
            variables: {
                partialName: input,
                numResults: numResults
            }
        });
    }, 200), [
        getSuggestions,
        numResults
    ]);
    (0,react.useEffect)(function() {
        var lowerUserInput = userInput.toLowerCase();
        // Reset selection when input changes, unless the change was a result of a chosen selection
        if (selectedName && selectedName.toLowerCase() !== lowerUserInput) {
            resetSelection();
        }
        // Never show suggestions if min character constraint not met or if a selection is already made
        if (!selectedName && isMinChars()) {
            // Use memoized suggestions if they exist
            var memoizedSuggestion = memoizedSuggestions[lowerUserInput];
            if (memoizedSuggestion) {
                setFormattedSuggestions(memoizedSuggestion);
                setInitialLoad(false);
            } else {
                // Debounced getSuggestions call
                debouncedGetSuggestions(lowerUserInput);
            }
        }
    }, [
        userInput
    ]);
    (0,react.useEffect)(function() {
        if (findCareGroupData) {
            onGetSuggestionsCompleted(findCareGroupData);
        }
    }, [
        findCareGroupData
    ]);
    (0,react.useEffect)(function() {
        // Memoize suggestions the first time we get valid unique input
        if (!memoizedSuggestions[userInput.toLowerCase()]) {
            setMemoizedSuggestions(function(prevValues) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), (0,_define_property/* default */.Z)({}, userInput.toLowerCase(), formattedSuggestions));
            });
        }
    }, [
        formattedSuggestions
    ]);
    (0,react.useEffect)(function() {
        if (serverError) onError(SERVER_ERROR_GENERIC);
    }, [
        serverError
    ]);
    var suggestionList = function() {
        if (!showSuggestions) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "suggestions",
            "data-testid": "suggestions",
            ref: suggestionsRef,
            children: formattedSuggestions.map(function(suggestion, i) {
                /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/mouse-events-have-key-events */ /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    className: i === 0 ? "highlight" : "",
                    onClick: function() {
                        return handleSuggestionSelect(suggestion);
                    },
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    },
                    onMouseOver: function() {
                        return handleHighlightAtIndex(i);
                    },
                    children: suggestion === null || suggestion === void 0 ? void 0 : suggestion.name
                }, suggestion === null || suggestion === void 0 ? void 0 : suggestion.name);
            })
        });
    };
    var blurInput = function() {
        var ref;
        (ref = groupInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
    };
    var handleKeyboardInput = function(e) {
        var length = formattedSuggestions === null || formattedSuggestions === void 0 ? void 0 : formattedSuggestions.length;
        var nextIndex = highlightedSuggestion;
        if (showSuggestions) {
            switch(e.nativeEvent.key){
                case "ArrowDown":
                    e.preventDefault(); // prevent moving the cursor inside the input while selecting options
                    nextIndex = (highlightedSuggestion + 1) % length;
                    handleHighlightAtIndex(nextIndex);
                    break;
                case "ArrowUp":
                    e.preventDefault(); // prevent moving the cursor inside the input while selecting options
                    nextIndex = (highlightedSuggestion ? highlightedSuggestion - 1 : length - 1) % length;
                    handleHighlightAtIndex(nextIndex);
                    break;
                case "Enter":
                    if (formattedSuggestions[highlightedSuggestion]) {
                        handleSuggestionSelect(formattedSuggestions[highlightedSuggestion]);
                    }
                    break;
                case "Escape":
                    blurInput();
                    break;
                default:
                    return;
            }
            setHighlightedSuggestion(nextIndex);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.lookup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                inputProps: {
                    ref: groupInputRef
                },
                autoFocus: autoFocus,
                id: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || "groupShortName",
                name: "groupShortName",
                label: "Employer name",
                autoComplete: "off",
                value: userInput,
                onKeyDown: handleKeyboardInput,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur,
                onChange: handleOnChange,
                FormHelperTextProps: helperTextProps
            }),
            suggestionList()
        ]
    });
};
/* harmony default export */ var CompanySearchInput_CompanySearchInput = (CompanySearchInput);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Link/Link.js
var Link = __webpack_require__(79769);
// EXTERNAL MODULE: ./src/components/shared/TermsOfUse.tsx
var TermsOfUse = __webpack_require__(99051);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/EnrollmentForm/EnrollmentForm.tsx












var CTA_TEXT = "Enroll now";
var EnrollmentForm_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        formContainer: (0,_define_property/* default */.Z)({
            marginBottom: function(param) {
                var headingMargin = param.headingMargin;
                return headingMargin;
            }
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            marginBottom: function(param) {
                var headingMarginMd = param.headingMarginMd;
                return headingMarginMd;
            }
        }),
        fields: {
            marginBottom: theme/* default.spacing */.Z.spacing(1),
            "& > .input-container": {
                paddingTop: 0,
                paddingBottom: 0
            },
            "& .MuiFormControl-root": {
                padding: 0
            }
        },
        buttonContainer: {
            textAlign: "center"
        },
        helperText: {
            "&.MuiFormHelperText-root": {
                color: theme/* default.palette.care.white */.Z.palette.care.white
            },
            "&.Mui-error": {
                color: theme/* default.palette.care.red.400 */.Z.palette.care.red[400]
            }
        },
        helperLink: {
            color: theme/* default.palette.care.white */.Z.palette.care.white,
            "&:hover,&:focus,&:focus:active": {
                color: theme/* default.palette.care.white */.Z.palette.care.white
            }
        },
        cta: (0,_define_property/* default */.Z)({
            width: "100%"
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("sm"), {
            maxWidth: "327px"
        }),
        ctaSecondary: {
            width: "100%",
            maxWidth: "233px"
        }
    };
});
var EnrollmentForm = function(param) {
    var id = param.id, logger = param.logger, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, disableAutoFocus = param.disableAutoFocus, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? CTA_TEXT : _ctaText, ctaTextLocation = param.ctaTextLocation;
    var emailRef = (0,react.useRef)();
    var headingMargin = variant === "primary" ? theme/* default.spacing */.Z.spacing(3) : theme/* default.spacing */.Z.spacing(4);
    var headingMarginMd = variant === "primary" ? theme/* default.spacing */.Z.spacing(2) : theme/* default.spacing */.Z.spacing(5);
    var classes = EnrollmentForm_useStyles({
        headingMargin: headingMargin,
        headingMarginMd: headingMarginMd
    });
    var buttonContainerClass = variant === "primary" ? "" : classes.buttonContainer;
    var buttonClass = variant === "primary" ? classes.cta : classes.ctaSecondary;
    var ref = hooks_useCompanySearchForm(logger), formik = ref.formik, memberExists = ref.memberExists, apolloError = ref.apolloError, loading = ref.loading, companySearchPreFillName = ref.companySearchPreFillName, shouldAutoFocusEmail = ref.shouldAutoFocusEmail, handleCompanySearchError = ref.handleCompanySearchError, handleSelection = ref.handleSelection, setSSOConnectionPath = ref.setSSOConnectionPath;
    var handleLogin = function() {
        logger({
            name: constants/* EventNames.LOGIN */.Vy.LOGIN,
            data: {
                login_location: constants/* LoginLocation.WELCOME_PAGE_EMAIL_ERROR */.gc.WELCOME_PAGE_EMAIL_ERROR
            }
        });
        window.location.href = "/vis/auth/login";
    };
    var handleCtaClick = function() {
        logger({
            name: constants/* EventNames.CTA_INTERACTED */.Vy.CTA_INTERACTED,
            data: {
                cta_location: ctaTextLocation,
                cta_text: ctaText
            }
        });
        if (Object.keys(formik.errors).length) {
            logger({
                name: constants/* EventNames.ERROR_VIEWED */.Vy.ERROR_VIEWED,
                data: {
                    error_type: "Form Validation Error",
                    message: Object.values(formik.errors)[0]
                }
            });
        }
    };
    var handleCompanySelect = function(selection, isPreFetch) {
        handleSelection(selection);
        // focus on email input
        if (selection.name && !isPreFetch) {
            var ref;
            (ref = emailRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    var helpText = memberExists && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "info1",
        className: classes.helperText,
        children: [
            constants/* TEXTS.ERRORS.EMAIL_ALREADY_EXISTS */.oS.ERRORS.EMAIL_ALREADY_EXISTS,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                onClick: handleLogin,
                variant: "link4",
                bold: true,
                className: classes.helperLink,
                children: " Log in?"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* FormikProvider */.Hy, {
            value: formik,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                id: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotification/* default */.Z, {
                        text: apolloError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.formContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                className: classes.fields,
                                spacing: 2,
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        sm: variant === "primary" ? 6 : 10,
                                        md: 6,
                                        className: "input-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchInput_CompanySearchInput, {
                                            inputProps: {
                                                id: "".concat(id, "_company")
                                            },
                                            helperTextProps: {
                                                className: classes.helperText
                                            },
                                            onSelection: handleCompanySelect,
                                            onError: handleCompanySearchError,
                                            setSSOConnectionPath: setSSOConnectionPath,
                                            autoFocus: !disableAutoFocus && !shouldAutoFocusEmail,
                                            prefillName: companySearchPreFillName,
                                            preFetch: Boolean(companySearchPreFillName)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        sm: variant === "primary" ? 6 : 10,
                                        md: 6,
                                        className: "input-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                                            inputProps: {
                                                ref: emailRef
                                            },
                                            id: "".concat(id, "_email"),
                                            name: "email",
                                            label: "Email",
                                            autoFocus: !disableAutoFocus && shouldAutoFocusEmail,
                                            helperText: helpText,
                                            FormHelperTextProps: {
                                                className: classes.helperText
                                            }
                                        })
                                    })
                                ]
                            }),
                            variant === "secondary" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsOfUse/* default */.Z, {
                                amplitudeLogger: logger,
                                buttonCaption: ctaText,
                                variant: "universal"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: buttonContainerClass,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: "large",
                            variant: "contained",
                            color: "primary",
                            type: "submit",
                            onClick: handleCtaClick,
                            disabled: loading,
                            className: buttonClass,
                            children: ctaText
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var EnrollmentForm_EnrollmentForm = (EnrollmentForm);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/EnrollmentForm/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/EnrollmentSection/EnrollmentSection.tsx









var EnrollmentSection_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        wrapper: {
            backgroundColor: theme/* default.palette.care.navy.800 */.Z.palette.care.navy[800]
        },
        container: (0,_define_property/* default */.Z)({
            paddingTop: theme/* default.spacing */.Z.spacing(6),
            paddingBottom: theme/* default.spacing */.Z.spacing(8)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("sm"), {
            paddingTop: theme/* default.spacing */.Z.spacing(8),
            paddingBottom: theme/* default.spacing */.Z.spacing(10)
        }),
        headline: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme/* default.spacing */.Z.spacing(3),
            paddingLeft: theme/* default.spacing */.Z.spacing(3),
            paddingRight: theme/* default.spacing */.Z.spacing(3),
            color: theme/* default.palette.care.white */.Z.palette.care.white
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            marginBottom: theme/* default.spacing */.Z.spacing(4),
            fontSize: theme/* default.typography.serifDisplay3.fontSize */.Z.typography.serifDisplay3.fontSize,
            lineHeight: theme/* default.typography.serifDisplay3.lineHeight */.Z.typography.serifDisplay3.lineHeight
        })
    };
});
var EnrollmentSection = function(param) {
    var logger = param.logger;
    var classes = EnrollmentSection_useStyles();
    var ref = hooks_useResponsive(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveDivider_WaveDivider, {
                position: POSITION.ABSOLUTE,
                backgroundColor: "transparent",
                shapeFill: theme/* default.palette.care.navy.800 */.Z.palette.care.navy[800],
                flipHorizontal: isMobile || isTablet
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "lg",
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "serifHeadline3",
                        component: "h2",
                        className: classes.headline,
                        children: "Ready to enroll in your Care benefits?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 9,
                            md: 8,
                            lg: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnrollmentForm_EnrollmentForm, {
                                id: "secondary_enrollment_form",
                                logger: logger,
                                variant: "secondary",
                                disableAutoFocus: true,
                                ctaText: "Join now",
                                ctaTextLocation: "Additional enrollment"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveDivider_WaveDivider, {
                position: POSITION.ABSOLUTE,
                backgroundColor: "transparent",
                shapeFill: theme/* default.palette.care.white */.Z.palette.care.white,
                flipHorizontal: isMobile || isTablet
            })
        ]
    });
};
/* harmony default export */ var EnrollmentSection_EnrollmentSection = (EnrollmentSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/EnrollmentSection/index.tsx


;// CONCATENATED MODULE: ./public/static/why-care.webp
/* harmony default export */ var why_care = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/why-care.ce56bde6.webp","height":734,"width":1184,"blurDataURL":"data:image/webp;base64,UklGRpQAAABXRUJQVlA4WAoAAAAQAAAABwAABAAAQUxQSCkAAAAAAAEAFOuECo8ABwBI/7zU/wMAXOv8+//6AFzz//3//f+X///7/////wBWUDggRAAAALABAJ0BKggABQACQDglAE6AHpLxvNwA/vdWc7nt9VfiR/6bbbr/04dxIa0ta78au6Tt/FWK9p2ruFF4MOM/3aDXzgAA","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandBgcCriminal.js
var Icon48BrandBgcCriminal = __webpack_require__(98340);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoResponseTime.js
var Icon24InfoResponseTime = __webpack_require__(89905);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/IconStars/IconStars.tsx


// todo: move double star icon to shared component library icon package
var IconStars = function(param) {
    var _size = param.size, size = _size === void 0 ? 45 : _size, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "-1 0 45 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.40899 38.0812C8.77575 38.2519 9.17546 38.3403 9.58002 38.34C10.0316 38.3359 10.4751 38.219 10.87 38L18.2218 34.152L19.4 35.3L18.06 43C17.9777 43.4532 18.0242 43.9204 18.1943 44.3484C18.3644 44.7765 18.6513 45.1481 19.0222 45.4212C19.3932 45.6942 19.8334 45.8576 20.2926 45.8927C20.7519 45.9279 21.2118 45.8334 21.62 45.62L28.54 42L35.42 45.83C35.7864 46.0367 36.1994 46.1468 36.62 46.15L36.6 46.17C36.9565 46.1656 37.3079 46.0846 37.6305 45.9327C37.953 45.7807 38.2392 45.5613 38.4695 45.2892C38.6999 45.017 38.8692 44.6986 38.9659 44.3555C39.0626 44.0123 39.0845 43.6523 39.03 43.3L37.72 35.38L43.3 30.16C43.6334 29.8455 43.8728 29.4444 43.9913 29.0017C44.1097 28.5589 44.1027 28.0919 43.9709 27.6529C43.8391 27.2139 43.5877 26.8203 43.245 26.516C42.9022 26.2117 42.4815 26.0088 42.03 25.93L34.24 24.59L33.5175 23.1627L39.48 17.58C39.855 17.2259 40.1242 16.7745 40.2573 16.2763C40.3905 15.778 40.3824 15.2526 40.2341 14.7586C40.0857 14.2647 39.8028 13.8218 39.4171 13.4794C39.0314 13.1371 38.5581 12.9087 38.05 12.82L27.5 11L22.8 1.73998C22.5664 1.28459 22.2107 0.903134 21.7728 0.638244C21.3348 0.373354 20.8318 0.235462 20.32 0.239976C19.8091 0.239393 19.308 0.380129 18.8721 0.64662C18.4361 0.91311 18.0824 1.29497 17.85 1.74998L13.14 11L2.63002 12.49C2.11833 12.5648 1.63765 12.7808 1.24201 13.1138C0.846372 13.4469 0.551459 13.8836 0.390424 14.375C0.229388 14.8665 0.208614 15.393 0.330436 15.8956C0.452257 16.3982 0.711846 16.8568 1.08002 17.22L8.66002 24.64L6.85002 35.09C6.77992 35.4884 6.79794 35.8974 6.90282 36.2881C7.00771 36.6788 7.1969 37.0418 7.45711 37.3516C7.71732 37.6614 8.04223 37.9104 8.40899 38.0812ZM30.2643 23.3002L28.6 20L25.25 26.56C25.1426 26.7754 24.9847 26.9616 24.7896 27.1027C24.5946 27.2438 24.3682 27.3355 24.13 27.37L16.68 28.43L19.55 31.24C19.5884 31.2768 19.6248 31.3157 19.6589 31.3562L22.06 33.7C22.2277 33.8684 22.3539 34.0735 22.4286 34.2992C22.5032 34.5248 22.5242 34.7648 22.49 35L21.2 42.45L27.86 39C28.079 38.8792 28.325 38.8158 28.575 38.8158C28.8251 38.8158 29.0711 38.8792 29.29 39L35.9 42.68L34.65 35.07C34.6113 34.826 34.6329 34.5763 34.7131 34.3427C34.7933 34.1091 34.9296 33.8987 35.11 33.73L40.48 28.73L33 27.4C32.7689 27.3598 32.5503 27.2666 32.3612 27.1278C32.1721 26.9891 32.0177 26.8084 31.91 26.6L30.35 23.52C30.3156 23.4486 30.287 23.3751 30.2643 23.3002ZM11.33 23L3.51002 15.34L14.34 13.8C14.5767 13.7649 14.8017 13.6741 14.9965 13.535C15.1912 13.3959 15.3501 13.2125 15.46 13L20.32 3.48998L25.16 13.06C25.266 13.2677 25.4187 13.448 25.6061 13.5868C25.7935 13.7256 26.0105 13.8191 26.24 13.86L37.15 15.73L32.15 20.38L30.8 17.72C30.5965 17.3129 30.2841 16.9702 29.8974 16.7301C29.5108 16.49 29.0651 16.3619 28.61 16.36C28.1543 16.3591 27.7072 16.4849 27.3187 16.7233C26.9303 16.9616 26.6157 17.3032 26.41 17.71L22.94 24.53L15.19 25.64C14.7321 25.6986 14.3005 25.8869 13.9461 26.1828C13.5917 26.4787 13.3294 26.8698 13.19 27.31C13.0438 27.7464 13.0234 28.2152 13.1313 28.6627C13.2392 29.1101 13.471 29.5181 13.8 29.84L16 32L9.88002 35.15L11.75 24.33C11.793 24.0908 11.7772 23.8449 11.704 23.6132C11.6308 23.3815 11.5025 23.1711 11.33 23Z",
            fill: "#213F5F"
        })
    });
};
/* harmony default export */ var IconStars_IconStars = (IconStars);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/IconStars/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/whyCareReasons.ts


var WHY_CARE_REASONS = [
    {
        headline: "The leading brand for Care",
        description: "Millions of families trust Care to find caregivers that fit their specific needs for children, seniors, pets, home, tutors, and more. That's why employers from Fortune 500 companies to small businesses count on Care to provide caregiving support to their employees.",
        icon: IconStars_IconStars
    },
    {
        headline: "Safety is our top priority",
        description: "Care sets the standard for safety among online care platforms. 100% of caregivers interacting with families have been background-checked with CareCheck, we provide tips and tools to help you have safe experiences, and stand ready to support you if you need it.",
        icon: Icon48BrandBgcCriminal/* default */.Z
    },
    {
        headline: "Get more done at work and at home",
        description: "Navigating caregiving challenges can be time-consuming and stressful. We help you to excel at work and thrive at home. 76% of employees said that their productivity has increased with Care benefits.",
        icon: Icon24InfoResponseTime/* default */.Z
    }, 
];

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/WhyCareItem/WhyCareItem.tsx





var WhyCareItem_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        heading: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            textAlign: "left"
        }),
        article: (_obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            display: "flex"
        }), (0,_define_property/* default */.Z)(_obj, "&:not(:last-of-type)", {
            marginBottom: theme.spacing(8)
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.only("md"), {
            marginLeft: theme.spacing(7)
        }), _obj),
        iconContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "center",
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            marginRight: theme.spacing(2)
        })
    };
});
var WhyCareSection = function(param) {
    var reason = param.reason;
    var classes = WhyCareItem_useStyles();
    var IconComponent = reason.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classes.article,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.iconContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {
                    size: 48
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h2",
                        component: "h4",
                        className: classes.heading,
                        children: reason.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: reason.description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WhyCareItem = (WhyCareSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/WhyCareItem/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/WhyCareSection/WhyCareSection.tsx









var WhyCareSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1;
    return {
        wrapper: (_obj = {
            backgroundColor: theme.palette.care.blue[100],
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(8)
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
            backgroundImage: "url(".concat(why_care.src, ")"),
            backgroundRepeat: "no-repeat",
            backgroundPosition: "calc(100% + 160px) 100%",
            backgroundSize: "auto 400px"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
            backgroundPosition: "100% 100%"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            paddingBottom: theme.spacing(12)
        }), _obj),
        subContainer: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("lg"), {
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6)
        }), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("xl"), {
            paddingLeft: theme.spacing(12),
            paddingRight: theme.spacing(12)
        }), _obj1),
        heading: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme.spacing(6)
        }, theme.breakpoints.up("lg"), {
            textAlign: "left"
        })
    };
});
var WhyCareSection_WhyCareSection = function() {
    var classes = WhyCareSection_useStyles();
    var ref = hooks_useResponsive(), isDesktop = ref.isDesktop, isLargeDesktop = ref.isLargeDesktop;
    var headingVariant = isDesktop ? "serifDisplay3" : "serifHeadline2";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        "data-testid": "WhyCareSection",
        className: classes.wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.subContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: headingVariant,
                        className: classes.heading,
                        children: "Why employees love their Care benefits"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        justifyContent: isLargeDesktop ? "flex-start" : "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            md: 10,
                            lg: 8,
                            xl: 7,
                            children: WHY_CARE_REASONS.map(function(reason) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyCareItem, {
                                    reason: reason
                                }, reason.headline);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_WhyCareSection_WhyCareSection = (WhyCareSection_WhyCareSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/WhyCareSection/index.tsx


// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./public/static/logos/best-buy.webp
/* harmony default export */ var best_buy = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/best-buy.91781342.webp","height":76,"width":120,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABAAAQUxQSCkAAAAAAAAAAAAAAAAflo1/e4QXACLEwpOmbQAAAJ3MmZ9/NAYAWHFeJojICwBWUDggVgAAANABAJ0BKggABQACQDglsAJ0APSMWV/gAP76ds3eyPdkh6Ii59wZXr1vyf4fjc5H+aLT6p8+X/zPoAidAH//M2+h/4OTFR/r//B23i/etXB7h75/pYAA","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/static/logos/vertex.webp
/* harmony default export */ var vertex = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/vertex.189d06aa.webp","height":76,"width":144,"blurDataURL":"data:image/webp;base64,UklGRoQAAABXRUJQVlA4WAoAAAAQAAAABwAAAwAAQUxQSCEAAAAAAAMAZ2EAAwAAAAfOzAUAAExGTGNLSkVFGkSHf26CQCMAVlA4IDwAAACwAQCdASoIAAQAAkA4JQBOgCHgfUOgAP7152pj2tk9j9dKb8gilsx2X163Yia2WHuKC7GU6ZQuYQ8AAAA=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/static/logos/toyota.webp
/* harmony default export */ var toyota = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/toyota.7530dfc7.webp","height":43,"width":260,"blurDataURL":"data:image/webp;base64,UklGRmAAAABXRUJQVlA4WAoAAAAQAAAABwAAAAAAQUxQSAkAAAAAR2A0WVFTV0oAVlA4IDAAAADQAQCdASoIAAEAAkA4JaACdLoB+AADsAD+8FMf/xZyMR2eb/8Ka+FNfCmv+ECAAAA=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/static/logos/sharp.webp
/* harmony default export */ var sharp = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/sharp.a988cb5f.webp","height":47,"width":148,"blurDataURL":"data:image/webp;base64,UklGRnoAAABXRUJQVlA4WAoAAAAQAAAABwAAAgAAQUxQSBkAAAAAYnNkbmB5gHZwYzhTW2pxWUqQRVB3eIswAFZQOCA6AAAAEAIAnQEqCAADAAJAOCWwAnS6AAMJGhfeAAD+2tay10S8NQtdRztz9ueaGaiZ5U33V/RYfM+IDIp4AA==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/static/logos/akamai.webp
/* harmony default export */ var akamai = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/akamai.f74e277a.webp","height":68,"width":170,"blurDataURL":"data:image/webp;base64,UklGRpQAAABXRUJQVlA4WAoAAAAQAAAABwAAAgAAQUxQSBkAAAAAhJREAAAAAACgFHhCKzYsQV5MhnuCcoB9AFZQOCBUAAAA0AIAnQEqCAADAAJAOCWwAnS6AUAB5gH6AAu4d1VwAAD+bJPy3oc3kY5r/yKpOWf4Wgnun/8aR5TEb8Mof5i38s8q7ifvzIwjB9AsDKr+Qfv2gAAA","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/static/logos/pandg.webp
/* harmony default export */ var pandg = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/pandg.50811059.webp","height":48,"width":104,"blurDataURL":"data:image/webp;base64,UklGRnQAAABXRUJQVlA4WAoAAAAQAAAABwAAAwAAQUxQSCEAAAAANLeoaQBNn0R8npbBb9AvBcSDcZ6HqzPY2gBgnJuLoX0AVlA4ICwAAADQAQCdASoIAAQAAkA4JaACdLoB+AADsAD+8Bvf/yU41+bv//+LORiO1pAAAA==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/static/logos/tripadvisor.webp
/* harmony default export */ var tripadvisor = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/tripadvisor.9db7c861.webp","height":84,"width":182,"blurDataURL":"data:image/webp;base64,UklGRpIAAABXRUJQVlA4WAoAAAAQAAAABwAAAwAAQUxQSCEAAAAAAwAJ19YIAAIAAA359gsAAEs2GWJsJyUkWIB3bmhvdWYAVlA4IEoAAACwAQCdASoIAAQAAkA4JYgAAxZgkeYwAP70xruOhffwKJCHsfX1+LbF+Hln3Obez8Dw2nxyNHvf/aBof1f6qdrBw/5OSSm9kAAAAA==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/static/logos/grant-thorton.webp
/* harmony default export */ var grant_thorton = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/grant-thorton.7135e1f7.webp","height":51,"width":252,"blurDataURL":"data:image/webp;base64,UklGRmIAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAApWUWHyseHxyvayU6KDQ2NABWUDggKgAAALABAJ0BKggAAgACQDgljAJ0AQ7+AuwA/vfhp67+t7+Ordnc9Bl+IwAAAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/employerLogos.ts








var EMPLOYER_LOGOS = [
    {
        name: "Best Buy",
        logo: best_buy.src,
        width: "60px",
        height: "38px"
    },
    {
        name: "Vertex",
        logo: vertex.src,
        width: "72px",
        height: "38px"
    },
    {
        name: "Toyota",
        logo: toyota.src,
        width: "130px",
        height: "21px"
    },
    {
        name: "Akamai",
        logo: akamai.src,
        width: "85px",
        height: "34px"
    },
    {
        name: "Sharp",
        logo: sharp.src,
        width: "74px",
        height: "23px"
    },
    {
        name: "P&G",
        logo: pandg.src,
        width: "52px",
        height: "24px"
    },
    {
        name: "TripAdvisor",
        logo: tripadvisor.src,
        width: "91px",
        height: "42px"
    },
    {
        name: "Grand Thorton",
        logo: grant_thorton.src,
        width: "126px",
        height: "25px"
    }, 
];

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/IconPlayVideo/IconPlayVideo.tsx


var IconPlayVideo = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 63 63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.5488 62.8882C48.6965 62.8882 62.5976 48.9872 62.5976 31.8394C62.5976 14.6916 48.6965 0.790619 31.5488 0.790619C14.401 0.790619 0.5 14.6916 0.5 31.8394C0.5 48.9872 14.401 62.8882 31.5488 62.8882ZM23.7883 45.8647L47.7129 32.0519L23.7883 18.239L23.7883 45.8647Z",
            fill: "white"
        })
    });
};
IconPlayVideo.defaultProps = {
    width: 64,
    height: 64
};
/* harmony default export */ var IconPlayVideo_IconPlayVideo = (IconPlayVideo);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/IconPlayVideo/index.ts


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TrustedSection/TrustedSection.tsx











var TrustedSection_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        wrapper: {
            backgroundColor: theme/* default.palette.care.blue.100 */.Z.palette.care.blue[100]
        },
        container: (0,_define_property/* default */.Z)({
            paddingTop: theme/* default.spacing */.Z.spacing(8),
            paddingBottom: theme/* default.spacing */.Z.spacing(10)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            paddingBottom: theme/* default.spacing */.Z.spacing(13)
        }),
        heading: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme/* default.spacing */.Z.spacing(2)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            fontSize: theme/* default.typography.serifDisplay3.fontSize */.Z.typography.serifDisplay3.fontSize,
            lineHeight: theme/* default.typography.serifDisplay3.lineHeight */.Z.typography.serifDisplay3.lineHeight
        }),
        logoContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            marginBottom: theme/* default.spacing */.Z.spacing(7)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            marginBottom: theme/* default.spacing */.Z.spacing(8)
        }),
        logoImage: {
            margin: theme/* default.spacing */.Z.spacing(2)
        },
        videoContainer: {
            display: "flex",
            justifyContent: "center"
        },
        videoPlayer: (0,_define_property/* default */.Z)({
            background: theme/* default.palette.care.grey.500 */.Z.palette.care.grey[500],
            display: "inline-block",
            borderRadius: "16px",
            overflow: "hidden",
            width: "336px",
            height: "190px"
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            width: "629px",
            height: "355px"
        })
    };
});
var TrustedSection = function() {
    var classes = TrustedSection_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-testid": "TrustedSection",
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveDivider_WaveDivider, {
                position: POSITION.ABSOLUTE,
                backgroundColor: "transparent",
                shapeFill: theme/* default.palette.care.blue.100 */.Z.palette.care.blue[100]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "lg",
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "serifHeadline3",
                        component: "h2",
                        className: classes.heading,
                        children: "Trusted by employers and employees around the globe"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.logoContainer,
                        children: EMPLOYER_LOGOS.map(function(logo) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.logoImage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: logo.logo,
                                    height: logo.height,
                                    width: logo.width,
                                    alt: "".concat(logo.name, " logo")
                                })
                            }, logo.name);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.videoContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.videoPlayer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                url: constants/* TRUSTED_VIDEO_URL */.bl,
                                controls: true,
                                playing: true,
                                light: true,
                                width: "100%",
                                height: "100%",
                                playIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlayVideo_IconPlayVideo, {})
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TrustedSection_TrustedSection = (TrustedSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TrustedSection/index.tsx


// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography_Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/FAQCompanyOffer/FAQCompanyOffer.tsx




var FAQCompanyOffer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
        variant: "body2",
        children: [
            "Type your employer‘s name in the form above. If your employer‘s name does not appear, please reach out to your HR representative or",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "https://www.care.com/lp/advocate",
                variant: "body2",
                target: "_blank",
                rel: "noreferrer noopener",
                children: "complete this form to advocate for Care."
            })
        ]
    });
};
/* harmony default export */ var FAQCompanyOffer_FAQCompanyOffer = (FAQCompanyOffer);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/FAQCompanyOffer/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/faqs.ts

var FAQS = [
    {
        question: "How do I know if my company offers benefits through Care?",
        answerComponent: FAQCompanyOffer_FAQCompanyOffer
    },
    {
        question: "How do I know if I'm eligible to enroll?",
        answer: "Eligibility requirements vary by employer. You may begin the enrollment process, but if you see an error message, please check with your HR representative to see if you are eligible. "
    },
    {
        question: "What information do I need to enroll?",
        answer: "Generally, you will need to provide your email address, first name, last name, birth date, and address. Some employers require your work email or employee ID to confirm eligibility, so it is a good idea to have those ready if you are prompted."
    },
    {
        question: "What if I already have a Care account?",
        answer: "If you have already used Care in the past and want to enroll in your benefits, please proceed through the enrollment process above with the same email as your current account. You will be prompted to merge your accounts, select yes to use the same login. If your employer requires you to use a work email, you may need to open a new account using that email address."
    },
    {
        question: "How do I know what benefits my employer provides?",
        answer: "Please enroll or log in to your Care account to see your entire benefits offering on the Member Home Page. You may also contact your HR representative for a full list of Care benefits available to you."
    },
    {
        question: "Do my benefits ever expire or change?",
        answer: "Your employer may change your Care benefits over time. Some benefits, like Backup Care allocations, may expire and refresh on an annual basis. Please check your Member Home Page for any updates and your current benefits or contact your HR representative."
    },
    {
        question: "What happens if I'm no longer employed by my company or if my company no longer offers benefits through Care?",
        answer: "When you leave an employer or your employer decides not to renew Care benefits, your access to all Care benefits ends immediately. You may still access the Care platform for other services."
    }, 
];

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/FAQAnswer/FAQAnswer.tsx



var FAQAnswer_FAQCompanyOffer = function(param) {
    var faq = param.faq;
    var AnswerComponent = faq.answerComponent;
    if (AnswerComponent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerComponent, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        variant: "body2",
        children: faq.answer
    });
};
/* harmony default export */ var FAQAnswer = (FAQAnswer_FAQCompanyOffer);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/FAQAnswer/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/FAQSection/FAQSection.tsx








var FAQSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(8)
        },
        heading: {
            textAlign: "center",
            marginBottom: theme.spacing(3)
        },
        accordionContainer: {
            "& .MuiAccordionSummary-root": {
                height: "auto",
                alignItems: "flex-start",
                minHeight: 0,
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2),
                lineHeight: "22px"
            },
            "& .MuiAccordionSummary-content": {
                margin: 0
            },
            "& .accordion-label-primary p": {
                fontWeight: "bold"
            }
        }
    };
});
var FAQSection = function(param) {
    var logger = param.logger;
    var classes = FAQSection_useStyles();
    var isDesktop = hooks_useResponsive().isDesktop;
    var headingVariant = isDesktop ? "serifDisplay3" : "serifHeadline4";
    var accordionClick = function(questionText) {
        logger({
            name: constants/* EventNames.LINK_INTERACTED */.Vy.LINK_INTERACTED,
            data: {
                screen_name: "Universal Landing Page",
                link_text: questionText
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        component: "section",
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            justifyContent: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                md: 10,
                lg: 7,
                xl: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: headingVariant,
                        className: classes.heading,
                        children: "Frequently asked questions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.accordionContainer,
                        children: FAQS.map(function(faq) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                elevation: 0,
                                onChange: function() {
                                    return accordionClick(faq.question);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionLabel/* default */.Z, {
                                        primaryLabel: faq.question
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionPanel/* default */.Z, {
                                        noPadding: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQAnswer, {
                                            faq: faq
                                        })
                                    })
                                ]
                            }, faq.question);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var FAQSection_FAQSection = (FAQSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/FAQSection/index.tsx


// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(16703);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityNextArrow.js
var Icon24UtilityNextArrow = __webpack_require__(89728);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
;// CONCATENATED MODULE: ./src/components/shared/Carousel.tsx










var Carousel_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            "& .control-dots": {
                marginBottom: theme.spacing(4)
            }
        },
        indicator: (0,_define_property/* default */.Z)({
            background: theme.palette.care.navy[800],
            width: theme.spacing(1),
            height: theme.spacing(1),
            display: "inline-block",
            margin: "0 8px",
            borderRadius: 10,
            cursor: "pointer"
        }, theme.breakpoints.down("sm"), {
            width: 5,
            height: 5,
            margin: "0 4px"
        }),
        indicatorSelected: (0,_define_property/* default */.Z)({
            width: theme.spacing(3)
        }, theme.breakpoints.down("sm"), {
            width: theme.spacing(2)
        })
    };
});
var Carousel = function(_param) {
    var containerClassName = _param.containerClassName, children = _param.children, _interval = _param.interval, interval = _interval === void 0 ? 4000 : _interval, renderArrowNext = _param.renderArrowNext, renderArrowPrev = _param.renderArrowPrev, shouldAutoPlay = _param.shouldAutoPlay, _shouldShowArrows = _param.shouldShowArrows, shouldShowArrows = _shouldShowArrows === void 0 ? false : _shouldShowArrows, width = _param.width, _logEvent = _param.logEvent, logEvent = _logEvent === void 0 ? function() {} : _logEvent, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "containerClassName",
        "children",
        "interval",
        "renderArrowNext",
        "renderArrowPrev",
        "shouldAutoPlay",
        "shouldShowArrows",
        "width",
        "logEvent"
    ]);
    var classes = Carousel_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        "data-testid": "carousel",
        className: (0,clsx_m/* default */.Z)([
            classes.root,
            containerClassName
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            preventMovementUntilSwipeScrollTolerance: true,
            swipeScrollTolerance: 50,
            autoPlay: shouldAutoPlay,
            dynamicHeight: false,
            emulateTouch: true,
            infiniteLoop: true,
            interval: interval,
            renderArrowNext: renderArrowNext,
            renderArrowPrev: renderArrowPrev,
            showArrows: shouldShowArrows,
            showStatus: false,
            showThumbs: false,
            stopOnHover: true,
            swipeable: true,
            width: width,
            renderIndicator: function(onClickHandler, isSelected, index, label) {
                if (isSelected) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (0,clsx_m/* default */.Z)([
                            classes.indicator,
                            classes.indicatorSelected
                        ]),
                        "aria-label": "Selected: ".concat(label, " ").concat(index + 1),
                        title: "Selected: ".concat(label, " ").concat(index + 1),
                        role: "option",
                        "aria-selected": "true"
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: classes.indicator,
                    onClick: function(e) {
                        logEvent();
                        onClickHandler(e);
                    },
                    onKeyDown: function(e) {
                        logEvent();
                        onClickHandler(e);
                    },
                    value: index,
                    role: "option",
                    "aria-selected": "false",
                    tabIndex: 0,
                    title: "".concat(label, " ").concat(index + 1),
                    "aria-label": "".concat(label, " ").concat(index + 1)
                }, index);
            }
        }, restProps), {
            children: children
        }))
    });
};
/* harmony default export */ var shared_Carousel = (Carousel);

;// CONCATENATED MODULE: ./public/static/testimonials/OP_avatar.png
/* harmony default export */ var OP_avatar = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/OP_avatar.8cc37f01.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/ANfh5nN9fwAAAExibVNpdgAAEmx2gNTe5wDc5ep0gII9OkawkpGvl5MACRlugZDP2uMAzNLYV15fTzU7w56b3ryzmXpwtp+ZvsHEAE1NUmFHQq2Ri4xcWbuSiqd1aNavp9O4sAAAAACcfnrYurafdXCXd3NfMCq6iYfguq8AiGdnuImFxp6deF1aoISMFDtcjmFg1qyeAObU2eDHyuvS0LWgoMWrrn6cvX+mxJqOlQDr19v35efu3d/bvr/Is7qBqMmWvtyguMw8Lm3IaMhimAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/testimonials/CS_avatar.png
/* harmony default export */ var CS_avatar = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/CS_avatar.037a3060.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/AN/h3Ly6tZZ+b6KgmnJ1dAoDAFhTTrSpogC0ubafgG/YnX5/UDV+YVPPnoSeeWSCcGcAiIeCuIp2y5F4qnlkvI94zJ6Gwp+KUkU9AFFLRb+OeNCagbF8Y7uJdeGwma+SgE5ANgAbODqMZE7VmXlPOyl9W0+bc18AAABXS0EAeGNWnn9qu4pqXVRNb1lKooRzX01DJhcIAKGOhJ2QhMi8sMSchM6egdqvl9i8qZBrWgDRuqqooJfBppLguZzduaHFn4rVw7XXspv6SmPYdoYnsQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/testimonials/JM_avatar.png
/* harmony default export */ var JM_avatar = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/JM_avatar.3cb28a28.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/AC0lJichJ3Vrc9PJxNfRw7i5t7q7vLy1sAA2KypDMzesm5zo4uLX3NnN09LLzs/Mzs8AV0RCa1FQy7a03tHVqKuvipSZlJGRtri6AG9UUJBoY8+1s8u1t0QnLwcAF5iWmaSoqwB9XlaOZ2LVt7WijIoAAAB4dXm/vsOorK0AgV9TUC8mtaemta+vdnh9naOuztHUwsXEAGVIPiwcFkNFRkhLT25wddbb4dja2tTU0QAlHh0AAAQAAAAAAABRUFOutcDDyM/Ly8lQZGTk3qACNQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/testimonials/PM_avatar.png
/* harmony default export */ var PM_avatar = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/PM_avatar.583a62ac.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/APr9/fjT1/Wutf3w8fv+/fX19ff39/f39wDw4+TDUWGcAACfbnPk4uL////4+Pf5+fkAvXSAkGBQZ0Mbu7m429vdysjI8/T17fDxALpeb5dFS4xNPs3DxrOin2AvEq6xscvY2wCnR1KvOlODWF1rRkeBTDleMSNgX1ugq6YAZj81kiE7sWZuelFWbjI6fFA9m5uHk6eUABwtQCIXJHcbMpc6To9DV5d2a7i6t63AwgArNEkKHS0AHCsALT8DNVZmd4qotrefrKw0hWqfI08kGgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/static/testimonials/LF_avatar.png
/* harmony default export */ var LF_avatar = ({"src":"/s/o/ent-enrollment-mfe/v1.200.1/bad1e8be4323a6b74eb9b5f47e2c5a8a4776a409/_next/static/media/LF_avatar.e17c194c.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/ANHP0s7Lz8/O0r22t6GRi8fHy8rJzcHBxgDJx8nIxsjMzdCypaKXem3FxcnDw8a9vsEA2NLU187Nwrq6hYB/kIWBx8XHz8rKzcfGAOfi5uPW18q7uZp0YYtmVNHLzdrR0KSclgDl3d/l4uXTwLd8VTF6YUyni3haUTURAAAA1s3NxcG9so92UnxWAHdNlnFYnYt7f3VnAMTBwMW4s49pUwBrQBxsQntVNaGFcZSGdwC+tq/SxMCBkH0AaSo2Yjx7XENvWkJeTDcVkXS3INm+AQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandChildcare.js
var Icon48BrandChildcare = __webpack_require__(98775);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandSeniorCare.js
var Icon48BrandSeniorCare = __webpack_require__(99344);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandCat.js
var Icon48BrandCat = __webpack_require__(23627);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandSpecialNeeds.js
var Icon48BrandSpecialNeeds = __webpack_require__(4303);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandBenefitBucks.js
var Icon48BrandBenefitBucks = __webpack_require__(637);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/testimonials.ts
/* eslint-disable camelcase */ 





var testimonials = [
    {
        quote: '"Backup Care has been incredibly beneficial to our family! My husband and I both work full-time and Backup Care has been a huge stress reliever for us. Our toddler absolutely loves the caregivers and asks for them by name all the time."',
        name: "O.P.",
        description: "Care benefits user",
        img: OP_avatar.src,
        icon: Icon48BrandChildcare/* default */.Z
    },
    {
        quote: '"Please accept my sincere and immense thanks for making calls and gathering information to help us make an informed decision about the best agency for my mom. It has taken a load off of my shoulders and I\'m very grateful!"',
        name: "C.S.",
        description: "Care benefits user",
        img: CS_avatar.src,
        icon: Icon48BrandSeniorCare/* default */.Z
    },
    {
        quote: "\"When I travel for work, it's important to know my cat is taken care of. If he gets lonely, he refuses to eat. Pet Backup Care gives me access to a \"friend\" to check in on him while I'm gone. He eats, he plays, he's happy ... I'm happy!\"",
        name: "J.M.",
        description: "Care benefits user",
        img: JM_avatar.src,
        icon: Icon48BrandCat/* default */.Z
    },
    {
        quote: '"Very easy to explain your needs and get matches that have background checks, DMV records, and references. I was able to find help in less than 48 hours. What a resource for single parents. I\'d give it a 10 if I could."',
        name: "P.M.",
        description: "Care benefits user",
        img: PM_avatar.src,
        icon: Icon48BrandSpecialNeeds/* default */.Z
    },
    {
        quote: '"I saved $300! I planned a family vacation with LifeMart and saved $300 in theme park admission, hotel, and minivan rentals. It also has local deals—try it out!"',
        name: "L.F.",
        description: "Care benefits user",
        img: LF_avatar.src,
        icon: Icon48BrandBenefitBucks/* default */.Z
    }, 
];

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js + 1 modules
var Card = __webpack_require__(33306);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TestimonialsCarouseltem/TestimonialsCarouseltem.tsx






var TestimonialsCarouseltem_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        cardWrapper: (0,_define_property/* default */.Z)({
            padding: "32px 10px 10px",
            height: "100%",
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,.15))"
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            paddingTop: "36px"
        }),
        card: {
            height: "100%",
            boxShadow: "none",
            position: "relative",
            overflow: "visible"
        },
        testimonialContainer: {
            height: "100%",
            display: "flex",
            alignItems: "center"
        },
        testimonial: (0,_define_property/* default */.Z)({
            padding: theme/* default.spacing */.Z.spacing(6, 6),
            textAlign: "left"
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("sm"), {
            padding: theme/* default.spacing */.Z.spacing(6, 10)
        }),
        iconWrapper: (0,_define_property/* default */.Z)({
            width: "56px",
            height: "56px",
            border: "2px solid ".concat(theme/* default.palette.grey.100 */.Z.palette.grey[100]),
            borderRadius: "50%",
            position: "absolute",
            left: "50%",
            top: "-28px",
            transform: "translateX(-50%)",
            background: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            width: "64px",
            height: "64px",
            top: "-32px"
        }),
        quote: {
            marginBottom: theme/* default.spacing */.Z.spacing(2)
        },
        img: {
            height: theme/* default.spacing */.Z.spacing(6),
            minWidth: theme/* default.spacing */.Z.spacing(6),
            maxWidth: theme/* default.spacing */.Z.spacing(6),
            borderRadius: "50%",
            marginRight: theme/* default.spacing */.Z.spacing(1)
        },
        tertiaryText: {
            color: theme/* default.palette.care.grey.600 */.Z.palette.care.grey[600]
        }
    };
});
var TestimonialsCarouselItem = function(param) {
    var _testimonial = param.testimonial, icon = _testimonial.icon, quote = _testimonial.quote, img = _testimonial.img, description = _testimonial.description, name = _testimonial.name;
    var classes = TestimonialsCarouseltem_useStyles();
    var iconComponent = function() {
        var IconComponent = icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {
            size: 48
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.cardWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: classes.card,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.testimonialContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.iconWrapper,
                        children: iconComponent()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.testimonial,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.quote,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    children: quote
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: img,
                                            alt: description,
                                            className: classes.img
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                className: classes.tertiaryText,
                                                children: description
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TestimonialsCarouseltem = (TestimonialsCarouselItem);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TestimonialsCarouseltem/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TestimonialsCarousel/TestimonialsCarousel.tsx










var TestimonialsCarousel_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        carouselWrapper: {
            position: "relative",
            width: "100%",
            maxWidth: "630px",
            "& .slider": {
                overflowY: "visible",
                height: "100%"
            }
        },
        carouselArrow: {
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            zIndex: 2,
            top: "calc(50% - 12px)",
            width: 24,
            height: 24,
            border: "none",
            backgroundColor: "transparent",
            color: theme/* default.palette.care.navy.800 */.Z.palette.care.navy[800],
            cursor: "pointer",
            "&:nth-of-type(1)": (0,_define_property/* default */.Z)({
                left: theme/* default.spacing */.Z.spacing(3),
                rotate: "180deg",
                transformOrigin: "center 13px"
            }, theme/* default.breakpoints.down */.Z.breakpoints.down("xs"), {
                left: theme/* default.spacing */.Z.spacing(2)
            }),
            "&:nth-of-type(2)": (0,_define_property/* default */.Z)({
                right: theme/* default.spacing */.Z.spacing(3)
            }, theme/* default.breakpoints.down */.Z.breakpoints.down("xs"), {
                right: theme/* default.spacing */.Z.spacing(2)
            })
        }
    };
});
var TestimonialsCarousel = function(param) {
    var logger = param.logger;
    var classes = TestimonialsCarousel_useStyles();
    var logCarouselInteraction = function() {
        logger({
            name: constants/* EventNames.LINK_INTERACTED */.Vy.LINK_INTERACTED,
            data: {
                link_text: "Testimonial carousel"
            }
        });
    };
    var renderArrow = function(direction) {
        return function(clickHandler, shouldRender) {
            return shouldRender && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: classes.carouselArrow,
                onClick: function() {
                    logCarouselInteraction();
                    clickHandler();
                },
                "aria-label": "".concat(direction, " slide"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityNextArrow/* default */.Z, {})
            });
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            item: true,
            xs: 12,
            sm: 8,
            md: 7,
            lg: 6,
            className: classes.carouselWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_Carousel, {
                shouldShowArrows: true,
                renderArrowPrev: renderArrow("previous"),
                renderArrowNext: renderArrow("next"),
                logEvent: logCarouselInteraction,
                children: testimonials.map(function(testimonial) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsCarouseltem, {
                        testimonial: testimonial
                    }, testimonial.name);
                })
            })
        })
    });
};
/* harmony default export */ var TestimonialsCarousel_TestimonialsCarousel = (TestimonialsCarousel);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TestimonialsCarousel/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TestimonialsSection/TestimonialsSection.tsx








var TestimonialsSection_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        testimonialsSection: {
            backgroundColor: theme/* default.palette.care.white */.Z.palette.care.white
        },
        container: (0,_define_property/* default */.Z)({
            margin: "0 auto",
            paddingTop: theme/* default.spacing */.Z.spacing(7),
            paddingBottom: theme/* default.spacing */.Z.spacing(12)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            paddingTop: theme/* default.spacing */.Z.spacing(8),
            paddingBottom: theme/* default.spacing */.Z.spacing(13)
        }),
        heading: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginBottom: theme/* default.spacing */.Z.spacing(4)
        }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
            fontSize: theme/* default.typography.serifDisplay3.fontSize */.Z.typography.serifDisplay3.fontSize,
            lineHeight: theme/* default.typography.serifDisplay3.lineHeight */.Z.typography.serifDisplay3.lineHeight
        })
    };
});
var TestimonialsSection = function(param) {
    var logger = param.logger;
    var classes = TestimonialsSection_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classes.testimonialsSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "serifHeadline2",
                    component: "h2",
                    className: classes.heading,
                    children: "In their own words"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsCarousel_TestimonialsCarousel, {
                    logger: logger
                })
            ]
        })
    });
};
/* harmony default export */ var TestimonialsSection_TestimonialsSection = (TestimonialsSection);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/TestimonialsSection/index.tsx


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/data/welcomeImages.ts

var oldCmsPrefix = "https://www.care.com//img/cms/web/careAtWork/directEnrollment";
var WELCOME_IMAGES = {
    FLORAL_LEFT: "".concat(constants/* CMS_PREFIX */.XM, "/Floral_Left_DT@4x-min.png"),
    FLORAL_RIGHT: "".concat(constants/* CMS_PREFIX */.XM, "/Floral_Right_DT@4x-min.png"),
    FLORAL_MW: "".concat(constants/* CMS_PREFIX */.XM, "/Floral_MW@4x-min.png"),
    MOM_AND_CHILD_DT: "".concat(constants/* CMS_PREFIX */.XM, "/photo@2x-min.png"),
    MOM_AND_CHILD_MW: "".concat(oldCmsPrefix, "/MomandchildMW.png"),
    FLORAL_CLUSTER_1: "".concat(oldCmsPrefix, "/floral_01.png"),
    FLORAL_CLUSTER_2: "".concat(oldCmsPrefix, "/Floral_cluster_02_portrait_4.png")
};

// EXTERNAL MODULE: ./src/components/shared/OverlaySpinner.tsx + 1 modules
var OverlaySpinner = __webpack_require__(20594);
;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/CompanySearchForm/style.ts


var style_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        fields: {
            marginBottom: theme.spacing(3),
            width: "calc(100% + 24px)",
            "& > .input-container": (0,_define_property/* default */.Z)({
                paddingTop: 0,
                paddingBottom: 0
            }, theme.breakpoints.up("md"), {
                minWidth: "280px",
                maxWidth: "408px",
                flexGrow: 1
            }),
            "& .MuiFormControl-root": {
                padding: 0
            }
        },
        fieldsUniversal: {
            marginBottom: theme.spacing(3),
            "& > .input-container": {
                paddingTop: 0,
                paddingBottom: 0
            },
            "& .MuiFormControl-root": {
                padding: 0
            }
        },
        button: (0,_define_property/* default */.Z)({
            display: "block",
            width: "100%",
            maxWidth: "327px",
            margin: "0 auto ".concat(theme.spacing(3), "px")
        }, theme.breakpoints.up("md"), {
            marginLeft: 0,
            marginRight: 0
        }),
        buttonUniversal: (0,_define_property/* default */.Z)({
            display: "block",
            width: "100%",
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up("sm"), {
            maxWidth: "300px"
        })
    };
});

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/CompanySearchForm/CompanySearchForm.tsx



















var CompanySearchForm_validationSchema = es/* object */.Ry({
    email: es/* string */.Z_().email("Enter a valid email").required("Email is required"),
    groupShortName: es/* string */.Z_().required("Employer name is required"),
    groupDisplayName: es/* string */.Z_().required("Employer name is required")
});
var CompanySearchForm = function(param) {
    var logger = param.logger, ctaText = param.ctaText, _variant = param.variant, variant = _variant === void 0 ? "control" : _variant;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,useDirectEnrollmentData/* default */.ZP)(), fetch = ref2.fetch, update = ref2.update;
    var storageValue = fetch();
    var excludeClients = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_REDIRECT_LD_FLAG.key */.y8.ENT_REDIRECT_LD_FLAG.key);
    var lifeCareTransitionD2EClients = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_LIFECARE_TRANSITION_D2E_CLIENT_FLAG.key */.y8.ENT_LIFECARE_TRANSITION_D2E_CLIENT_FLAG.key);
    var ref3 = (0,react.useState)(false), memberExists = ref3[0], setMemberExists = ref3[1];
    var ref4 = (0,react.useState)(""), apolloError = ref4[0], setApolloError = ref4[1];
    var ref5 = (0,react.useState)(false), isSubmitting = ref5[0], setIsSubmitting = ref5[1];
    var ref6 = (0,react.useState)(""), ssoConnectionPath = ref6[0], setSSOConnectionPath = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GQL/* VERIFY_EMPLOYEE_EXISTS_BY_EMAIL */.tc, {
        context: {
            skipAuth: true
        },
        onCompleted: function(verifyEmployeeData) {
            var enterpriseVerifyEmployeeExistsByEmail = verifyEmployeeData.enterpriseVerifyEmployeeExistsByEmail;
            if (enterpriseVerifyEmployeeExistsByEmail.__typename === "EnterpriseVerifyEmployeeExistsByEmailSuccess") {
                var alreadyExists = enterpriseVerifyEmployeeExistsByEmail.memberExists;
                if (!alreadyExists) {
                    if (ssoConnectionPath) {
                        window.location.href = ssoConnectionPath;
                        return;
                    }
                    if (Boolean(lifeCareTransitionD2EClients) && storageValue.groupShortName in lifeCareTransitionD2EClients) {
                        router.push("".concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.LIFECARE_AUTHENTICATION */.O$.LIFECARE_AUTHENTICATION, "?groupShortName=").concat(storageValue.groupShortName));
                        return;
                    }
                    router.push("".concat(constants/* memberEnrollment */.y).concat(constants/* ENTERPRISE_ROUTES.PERSONAL_INFO */.O$.PERSONAL_INFO));
                    return;
                }
                if (alreadyExists) {
                    logger({
                        name: constants/* EventNames.ERROR_VIEWED */.Vy.ERROR_VIEWED,
                        data: {
                            message: constants/* TEXTS.ERRORS.EMAIL_ALREADY_EXISTS */.oS.ERRORS.EMAIL_ALREADY_EXISTS,
                            step_name: "Welcome",
                            step_number: "0",
                            wps_group: formik.values.groupShortName
                        }
                    });
                }
                setMemberExists(enterpriseVerifyEmployeeExistsByEmail.memberExists);
            }
            if (enterpriseVerifyEmployeeExistsByEmail.__typename === "EnterpriseFailureResponse") {
                setApolloError(enterpriseVerifyEmployeeExistsByEmail.knownErrors[0].message);
            }
            setIsSubmitting(false);
        },
        onError: function() {
            setIsSubmitting(false);
            setApolloError(constants/* TEXTS.ERRORS.UNEXPECTED_ERROR */.oS.ERRORS.UNEXPECTED_ERROR);
        }
    }), 2), verifyEmployeeExists = ref7[0], loading = ref7[1].loading;
    var classes = style_useStyles();
    var buttonClass = variant === "universal" ? classes.buttonUniversal : classes.button;
    var fieldsClass = variant === "universal" ? classes.fieldsUniversal : classes.fields;
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var groupShortName, groupDisplayName, email;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setIsSubmitting(true);
                groupShortName = values.groupShortName, groupDisplayName = values.groupDisplayName, email = values.email;
                update({
                    groupShortName: groupShortName,
                    groupDisplayName: groupDisplayName,
                    email: email
                });
                if (Boolean(excludeClients) && groupShortName in excludeClients) {
                    window.location.href = "".concat(window.location.protocol, "//").concat(window.location.host, "/").concat(groupShortName);
                    return [
                        2
                    ];
                }
                if (email && groupShortName) {
                    verifyEmployeeExists({
                        variables: {
                            input: {
                                email: email,
                                groupShortName: groupShortName
                            }
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            groupShortName: storageValue.groupShortName,
            groupDisplayName: storageValue.groupDisplayName,
            email: storageValue.email
        },
        validationSchema: CompanySearchForm_validationSchema,
        validateOnBlur: true,
        onSubmit: handleFormSubmit
    });
    var handleSelection = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var name, shortName;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = param.name, shortName = param.shortName;
                        formik.setFieldValue("groupShortName", shortName);
                        formik.setFieldValue("groupDisplayName", name);
                        if (!(name.length >= 2)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            formik.setFieldTouched("groupShortName", true, true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            formik.setFieldTouched("groupDisplayName", true, true)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelection(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCtaClick = function() {
        logger({
            name: constants/* EventNames.CTA_INTERACTED */.Vy.CTA_INTERACTED,
            data: {
                cta_text: ctaText,
                user_email: formik.values.email,
                wps_group: formik.values.groupShortName,
                lifecare_transition_client: isLifecareTransitionClient().toString(),
                sso_client: Boolean(ssoConnectionPath).toString()
            }
        });
    };
    var isLifecareTransitionClient = function() {
        return formik.values.groupShortName ? formik.values.groupShortName in lifeCareTransitionD2EClients : false;
    };
    var handleLogin = function() {
        logger({
            name: constants/* EventNames.LOGIN */.Vy.LOGIN,
            data: {
                login_location: constants/* LoginLocation.WELCOME_PAGE_EMAIL_ERROR */.gc.WELCOME_PAGE_EMAIL_ERROR
            }
        });
        window.location.href = "/vis/auth/login";
    };
    var handleCompanySearchError = function(errorMessage) {
        formik.setFieldError("groupShortName", errorMessage);
        formik.setFieldTouched("groupShortName", true, false);
    };
    var helpText = memberExists && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        color: "error",
        careVariant: "info1",
        children: [
            constants/* TEXTS.ERRORS.EMAIL_ALREADY_EXISTS */.oS.ERRORS.EMAIL_ALREADY_EXISTS,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                onClick: handleLogin,
                careVariant: "link4",
                bold: true,
                children: " Log in?"
            })
        ]
    });
    var companySearchPreFillName = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.groupName) || (storageValue === null || storageValue === void 0 ? void 0 : storageValue.groupDisplayName) || "";
    var shouldAutoFocusEmail = Boolean(companySearchPreFillName) && !storageValue.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlaySpinner/* default */.Z, {
                isTransparent: true,
                isOpen: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* FormikProvider */.Hy, {
                value: formik,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    id: "primary_enrollment_form",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorNotification/* default */.Z, {
                            text: apolloError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            className: fieldsClass,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    sm: variant === "universal" ? 6 : 12,
                                    md: 6,
                                    className: "input-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchInput_CompanySearchInput, {
                                        onSelection: handleSelection,
                                        onError: handleCompanySearchError,
                                        setSSOConnectionPath: setSSOConnectionPath,
                                        autoFocus: !shouldAutoFocusEmail,
                                        prefillName: companySearchPreFillName,
                                        preFetch: Boolean(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.groupName)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    sm: variant === "universal" ? 6 : 12,
                                    md: 6,
                                    className: "input-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInlineTextField/* default */.Z, {
                                        autoFocus: shouldAutoFocusEmail,
                                        id: "email",
                                        name: "email",
                                        label: "Email",
                                        helperText: helpText
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "submit",
                            size: "large",
                            variant: "contained",
                            color: "primary",
                            onClick: handleCtaClick,
                            disabled: loading,
                            className: buttonClass,
                            children: ctaText
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CompanySearchForm_CompanySearchForm = (CompanySearchForm);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/CompanySearchForm/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/Hero/Hero.tsx











var Hero = function(param) {
    var logger = param.logger, hideFlowers = param.hideFlowers;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.down */.Z.breakpoints.down("xs"));
    var isTablet = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.only */.Z.breakpoints.only("sm"));
    var isLargeDesktop = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.up */.Z.breakpoints.up("lg"));
    var floralClusterImg = {
        src: WELCOME_IMAGES.FLORAL_LEFT,
        alt: "cluster of flowers",
        className: "flowerLeft"
    };
    var floralImg = {
        src: WELCOME_IMAGES.FLORAL_RIGHT,
        alt: "flower",
        className: "flowerRight"
    };
    var momAndChildImg = {
        src: WELCOME_IMAGES.MOM_AND_CHILD_DT,
        alt: "mother reading with child",
        className: "heroImage"
    };
    var headerText = "Join to find care when and where you need it";
    var subHeaderText = "Get access to your free, employer-sponsored account today";
    var classes = (0,makeStyles/* default */.Z)(function() {
        var _obj, _obj1;
        return {
            heroWrapper: {
                backgroundColor: theme/* default.palette.care.grey.50 */.Z.palette.care.grey[50],
                position: "relative"
            },
            heroContent: (_obj = {
                padding: theme/* default.spacing */.Z.spacing(3, 3, 10),
                zIndex: 1,
                position: "relative",
                maxWidth: "456px"
            }, (0,_define_property/* default */.Z)(_obj, theme/* default.breakpoints.up */.Z.breakpoints.up("sm"), {
                padding: theme/* default.spacing */.Z.spacing(6, 3, 10)
            }), (0,_define_property/* default */.Z)(_obj, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
                padding: theme/* default.spacing */.Z.spacing(6, 4, 6),
                maxWidth: "1440px"
            }), (0,_define_property/* default */.Z)(_obj, theme/* default.breakpoints.up */.Z.breakpoints.up("lg"), {
                padding: theme/* default.spacing */.Z.spacing(10)
            }), (0,_define_property/* default */.Z)(_obj, "& .header", {
                marginTop: "0px",
                marginBottom: theme/* default.spacing */.Z.spacing(2)
            }), (0,_define_property/* default */.Z)(_obj, "& .subHeader", {
                marginTop: "0px",
                marginBottom: theme/* default.spacing */.Z.spacing(2)
            }), _obj),
            heroBackground: {
                overflow: "hidden",
                display: "block",
                position: "absolute",
                width: "100%",
                height: "100%",
                "& .flowerLeft": {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    height: "144px",
                    width: "100px"
                },
                "& .flowerRight": (0,_define_property/* default */.Z)({
                    position: "absolute",
                    left: "unset",
                    right: 0,
                    top: 0,
                    height: "72px",
                    width: "123px"
                }, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
                    left: "6%",
                    right: "unset"
                }),
                "& .heroImageWrapper": (_obj1 = {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    height: "100%",
                    width: "100%"
                }, (0,_define_property/* default */.Z)(_obj1, theme/* default.breakpoints.up */.Z.breakpoints.up("md"), {
                    width: "40%"
                }), (0,_define_property/* default */.Z)(_obj1, theme/* default.breakpoints.up */.Z.breakpoints.up("lg"), {
                    width: "42%"
                }), _obj1),
                "& .heroImage": {
                    paddingBottom: "0",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    height: "100%",
                    width: "100%"
                }
            }
        };
    })();
    // This is a temporary optimization. By appending the `?im=` parameter, we are getting an optimized image from Akamai.
    // Images optimized in this way are cached on edge servers only after first fetch from each server and stay cached for at least 30 days.
    // TODO - replace with standard loader once we establish one.
    var imageLoader = function(param) {
        var src = param.src;
        return "".concat(src, "?im=");
    };
    var floralClusterImage = !hideFlowers && isLargeDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: floralClusterImg.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            priority: true,
            src: floralClusterImg.src,
            alt: floralClusterImg.alt,
            layout: "fill",
            objectFit: "contain",
            loader: imageLoader,
            sizes: "50vw"
        })
    });
    var heroImage = !isMobile && !isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: momAndChildImg.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            priority: true,
            src: momAndChildImg.src,
            alt: momAndChildImg.alt,
            layout: "fill",
            objectFit: "cover",
            objectPosition: "left center",
            loader: imageLoader,
            sizes: "50vw"
        })
    });
    var flowerRightImage = !hideFlowers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: floralImg.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            priority: true,
            src: floralImg.src,
            alt: floralImg.alt,
            layout: "fill",
            objectFit: "contain",
            loader: imageLoader,
            sizes: "50vw"
        })
    });
    var renderSearchForm = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: isMobile ? "h1" : "display3",
                    className: "header",
                    children: headerText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    className: "subHeader",
                    children: subHeaderText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchForm_CompanySearchForm, {
                            logger: logger,
                            ctaText: ENROLLMENT_CTA_TEXT
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsOfUse/* default */.Z, {
                            amplitudeLogger: logger,
                            buttonCaption: ENROLLMENT_CTA_TEXT,
                            variant: "abbreviated",
                            flat: true
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classes.heroWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.heroBackground,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "heroImageWrapper",
                        children: [
                            heroImage,
                            flowerRightImage
                        ]
                    }),
                    floralClusterImage
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classes.heroContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: renderSearchForm()
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/components/Hero/index.tsx


;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/WelcomePage.tsx


















var WelcomePage_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        // todo: update LandingPageHeader component to apply override styles
        headerWrapper: {
            "& > div:first-of-type": (0,_define_property/* default */.Z)({
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1)
            }, theme.breakpoints.up("md"), {
                paddingTop: theme.spacing(3),
                paddingBottom: theme.spacing(3)
            })
        },
        loginButton: {
            width: "118px"
        }
    };
});
var WelcomePage = function() {
    var logger = (0,analyticsHelper/* useEventLogger */.ld)({
        screen_name: "Universal Landing Page",
        user_flow: "Universal Landing Page"
    });
    var utmRedirectLdFlagResult = (0,FeatureFlagsContext/* useFlag */.P5)(constants/* FEATURE_FLAGS.ENT_UTM_REDIRECT_FLAG.key */.y8.ENT_UTM_REDIRECT_FLAG.key);
    var update = (0,useDirectEnrollmentData/* default */.ZP)().update;
    var classes = WelcomePage_useStyles();
    var handleLogin = function() {
        window.location.href = "/vis/auth/login";
    };
    var headerButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        color: "secondary",
        variant: "outlined",
        className: classes.loginButton,
        onClick: handleLogin,
        children: "Login"
    });
    (0,react.useEffect)(function() {
        update({
            utmRedirectFlagEnabled: utmRedirectLdFlagResult
        });
        logger({
            name: constants/* EventNames.SCREEN_VIEWED */.Vy.SCREEN_VIEWED
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "UniversalLandingPage",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.headerWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageHeader/* default */.Z, {
                    button: headerButton,
                    logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareLogo/* default */.Z, {
                        variant: "secondary"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Hero, {
                logger: logger,
                hideFlowers: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BenefitsSection_BenefitsSection, {
                logger: logger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WhyCareSection_WhyCareSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsSection_TestimonialsSection, {
                logger: logger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedSection_TrustedSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnrollmentSection_EnrollmentSection, {
                logger: logger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection_FAQSection, {
                logger: logger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var WelcomePage_WelcomePage = (WelcomePage);

;// CONCATENATED MODULE: ./src/components/pages/WelcomePage/index.tsx


;// CONCATENATED MODULE: ./src/pages/member-enrollment/welcome.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [932,923,200,774,888,179], function() { return __webpack_exec__(6562); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);